// AMQP Queues
exports.TOWER_QUEUE_NAME = 'tower-queue';
exports.TOWER_SCHEDULER_QUEUE_NAME = 'tower-scheduler-queue';
exports.AD_SYNC_QUEUE_NAME = 'ad-sync-queue';
exports.CORE_API_QUEUE_NAME = 'core-api-queue';
exports.DEAD_LETTERS_QUEUE_NAME = 'dead_letters_queue';
exports.DEAD_LETTERS_EXCHANGE_NAME = 'dead_letters';
exports.AUTH_LOGS_OPERATIONAL_QUEUE_NAME = 'auth_logs_operational_queue';
exports.AUTH_LOGS_RISK_QUEUE_NAME = 'auth_logs_risk_queue';
exports.AUTH_LOGS_DUMPER_QUEUE_NAME = 'auth_logs_dumper_queue';
exports.AUTH_LOGS_TOWER_QUEUE_NAME = 'auth_logs_tower_queue';
exports.DATA_STREAMER_QUEUE_NAME = 'data_batches_queue';
exports.OIDC_AUTH_LOGS_QUEUE_NAME = 'oidc_auth_logs_queue';
exports.POLICY_UPDATES_MESSAGES_QUEUE_NAME = 'policy_updates_messages_queue';
exports.USER_TOKENS_UPDATES_MESSAGES_QUEUE_NAME = 'user_tokens_updates_messages_queue';
exports.DUMPER_QUEUE_NAME = 'dumper_queue';
exports.RULES_SYNC_QUEUE_NAME = 'rules_sync_queue';
exports.INCIDENTS_QUEUE_NAME = 'incidents-api-requests';
exports.RABBIT_DEFAULT_REPLY_QUEUE = 'amq.rabbitmq.reply-to';
exports.INCIDENTS_REINDEX_TASKS_QUEUE_NAME = 'incidents_reindex_tasks_queue';
exports.INCIDENTS_MATCHED_AUTHS_QUEUE_NAME = 'incidents_matched_auths_queue';
exports.INCIDENTS_MATCHED_EVENT_LOGS_QUEUE_NAME = 'incidents_matched_event_logs_queue';
exports.INCIDENTS_ENGINE_AUTHS_QUEUE_NAME = 'incidents_engine_auths_queue';
exports.INCIDENTS_ENGINE_EVENT_LOGS_QUEUE_NAME = 'incidents_engine_event_logs_queue';
exports.INCIDENTS_COMMON_EXCHANGE_NAME = 'incidents_common_exchange';
exports.AUTHENTICATIONS_TOPIC_EXCHANGE = 'authentications_exchange';
exports.AUTHENTICATIONS_PARSED_QUEUE = 'authentications_parsed';
exports.AUTHENTICATIONS_RAW_QUEUE = 'authentications_raw';
exports.EVENT_STREAMER_EXCHANGE_NAME = 'event-streamer';
exports.MANAGEMENT_EVENT_STREAMER_EXCHANGE_NAME = 'management-event-streamer';
exports.AUTH_EVENT_STREAMER_QUEUE_NAME = 'auth-event-queue';
exports.MANAGEMENT_EVENT_STREAMER_QUEUE_NAME = 'management-event-queue';
exports.EVENT_STREAMER_LEADER_QUEUE_NAME = 'event-streamer-leader-queue';

exports.ELASTIC_INSERTION_DELAY = 1500;

exports.MANAGEMENT_EVENT_STREAMER_MESSAGE_TYPES = {
    UPDATE_CONNECTORS: 'UpdateConnectors',
    CHECK_FILE_STORAGE_UPPER_LIMIT: 'CheckFileStorageUpperLimit'
};

exports.EVENT_STREAMER_LEADER_MESSAGE_TYPES = {
    CHECK_IDLE_FILES: 'CheckIdleFiles',
    RESEND_FAILED_TO_SEND_FILES: 'ResendFailedToSendFiles',
    CHECK_FILE_STORAGE_LOWER_LIMIT: 'CheckFileStorageLowerLimit'
};

// Tower Queue Message Types
exports.TOWER_QUEUE_MESSAGES = {
    AD_SYNC_START: 'ADSyncStart',
    AD_SYNC_FINISH: 'ADSyncFinish',
    AD_SYNC_STATUS_UPDATED: 'AdSyncStatusUpdated',
    ADD_EVENTS: 'AddEvents',
    ADD_NOTIFICATIONS: 'AddNotifications',
    REMOVE_NOTIFICATIONS: 'RemoveNotifications',
    ASSIGN_PORT: 'AssignPort',
    REFRESH_CONNECTION_STRINGS: 'RefreshConnectionStrings',
    REFRESH_PHOENIX_TOKENS: 'RefreshPhoenixTokens',
    SEND_MAIL: 'SendMail',
    LOG_ABNORMAL_SERVICE_ACCOUNT: 'LogAbnormalServiceAccount',
    LOG_ABNORMAL_PRIVILEGED_ACCOUNT: 'LogAbnormalPrivilegedAccount',
    SEND_RETROSPECTIVE_MAIL: 'SendRetrospectiveMail',
    DC_VERSION_UPDATED: 'DCVersionUpdated',
    UPDATE_ALARMS_FROM_WALL_STATUS: 'UpdateAlarmsFromWallStatus',
    LOGS_UPLOADED: 'LogsUploaded',
    TEST_ACCOUNT_RESULT: 'TestAccountResult',
    TEST_MFA_RESULT: 'TestMFAResult',
    CHECK_REGISTER_USER: 'CheckRegisterUser',
    NEW_USER: 'NewUser',
    PRODUCT_DATA_EVENT: 'ProductDataEvent',
    CUSTOM_SPNS_UPDATE_RESULT: 'CustomSpnsUpdateResult',
    DELETE_NODE: 'DeleteNode',
    NOTIFY_RULES_SYNC_MEMBERSHIPS: 'NotifyRulesSyncMemberships',
    NEW_INCIDENT: 'NewIncident',
    INCIDENT_AUTH_LOGS: 'incidentAuthLogs',
    RESET_ACCOUNT_MATCHING_FINISH: 'ResetAccountMatchingFinish',
    HANDLE_UPDATE_ACCOUNT_MATCHING_FINISH: 'HandleUpdateAccountMatchingFinish',
    SYNC_LOCAL_ACCOUNTS_FINISH: 'SyncLocalAccountsFinish',
    HANDLE_UPDATE_LOCAL_ACCOUNTS_BINDS_FINISH: 'HandleUpdateLocalAccountsBindsFinish',
    WINDOWS_LOGON_SYSTEM_REPORT: 'WindowsLogonSystemReport',
    UPLOAD_DUMP_FILE_IMMEDIATE: 'UploadDumpFileImmediate'
};

exports.TOWER_SCHEDULER_QUEUE_MESSAGES = {
    SNAPSHOT_INSIGHT_STATS: 'snapshotInsightStats',
    PAS_CUSTOM_DEFAULTS: 'SetCustomDefaultPrivilegeAccounts',
    PAS_FLAT_TIERS: 'SetPrivilegeAccountsTiers',
    PAS_CALC_STATISTICS: 'CalcPrivilegedAccountStatisticInterval',
    PAS_REMOVE_PA_UNUSED_TIERS: 'RemovePAUnusedTiers',
    SEND_RISK_STATS: 'sendRiskStats',
    RECONNECT_TO_ELASTIC: 'reconnectToElastic',
    VALIDATE_STUNNEL_DATA: 'validateStunnelData',
    SYNC_DISCOVERY_DATA: 'syncDiscoveryData',
    REFRESH_STATISTICS: 'refreshStatistics',
    SEND_ARYA_SETTINGS: 'sendAryaSettings',
    RUN_FULL_AD_SYNC: 'runFullAdSyncFunc',
    RUN_DELTA_AD_SYNC: 'runDeltaAdSyncFunc',
    RUN_FULL_RISK_AD_SYNC: 'runFullRiskAdSyncFunc',
    RUN_DELTA_RISK_AD_SYNC: 'runDeltaRiskAdSyncFunc',
    UPDATE_DISCONNECTED_DCS_ALARMS: 'updateDisconnectedDcsAlarms',
    SYNC_AD_USERS_TO_PROTECTED_USERS: 'syncAdUsersToProtectedUsers',
    UPDATE_DISCONNECTED_PUSH_SERVICES_ALARMS: 'updateDisconnectedPushServicesAlarms',
    SEND_FULL_SYSTEM_STATUS: 'sendFullSystemStatus',
    ADD_CONNECT_DISCONNECTED_NOTIFICATION: 'addAdConnectDisconnectedNotifications',
    SEND_TOWER_SETTINGS: 'sendTowerSettings',
    CHECK_SEND_LOGS_EXPIRED: 'checkSendLogsExpired',
    VALIDATE_CERTIFICATES: 'validateCertificates',
    LOG_INSIGHTS_DAILY_BATCH: 'logInsightsDailyBatch',
    LOG_SPLUNK_SA_INSIGHTS: 'logSplunkServiceAccountsInsights',
    LOG_SPLUNK_INSIGHTS_DAILY: 'SplunkInsightsBatchSchedule',
    LOG_DAILY_AUTH_STATISTIC: 'logDailyAuthStatistic',
    LOG_SETTINGS: 'logSettings',
    LOG_DOCKER_STATS: 'logDockerStats',
    CHECK_REPORT_TO_SEND: 'checkReportsToSend',
    SEND_FULL_SYSTEM_STATISTIC: 'sendFullSystemStatistics',
    PROTECTED_USERS_CALCULATION: 'ProtectedUsersCalculation',
    REBALANCE_AZ: 'rebalanceAz',
    RESOLVE_OLD_NOTIFICATION: 'resolveOldNotifications',
    RISK_ENTITIES_STATISTICS: 'riskEntitiesStatistics',
    GET_DT_STATUS: 'getDRStatus',
    SHOW_DT_STATUS: 'shoeDRStatus',
    PRODUCT_DAILY_DATA: 'productDailyData',
    PRODUCT_DAILY_POLICY: 'productDailyPolicy',
    PRODUCT_DAILY_PROTECTION_DASHBOARD: 'productDailyProtectionDashboard',
    PRODUCT_DAILY_USERS_COUNT: 'productDailyUsersCount',
    PRODUCT_DAILY_LOCAL_USERS: 'productDailyLocalUsers',
    PRODUCT_INSIGHTS: 'productInsights',
    PRODUCT_EXPOSURES: 'productExposures',
    PRODUCT_EXPOSURES_CONFIGS: 'productExposuresConfigs',
    PRODUCT_PAGE_VIEW: 'productPagesView',
    PRODUCT_INCIDENTS: 'productIncidents',
    PRODUCT_INCIDENTS_CONFIGS: 'productIncidentsConfigs',
    REST_INCIDENTS_LIMIT: 'resetIncidentsLimit',
    AUTO_AD_ADAPTER: 'autoADAdapter',
    TOWER_MIN_DISK_SPACE: 'TowerMinDiskSpace',
    DELETE_LIMIT_COUNTER: 'deleteLimitCounter',
    SYSTEM_LIMITS_CALC: 'systemLimitsCalc',
    SYSTEM_LIMIT_CHECK: 'systemLimitsCheck',
    HANDLE_ON_GOING_INCIDENTS: 'handleOngoingIncidents',
    NEW_INCIDENT: 'NewIncident',
    AZURE_APPLICATION_SYNC: 'azureApplicationsSync',
    OKTA_APPLICATION_SYNC: 'ApplicationsSync',
    SERVICE_ACCOUNT_AUTO_PROTECT: 'serviceAccountAutoProtect',
    SEND_PRODUCT_WEBHOOK: 'sendProductWebhook',
    SEND_PRODUCT_DATA_VM: 'sendProductDataVM',
    UPLOAD_SYSTEM_BACKUP: 'uploadSystemBackup',
    SEND_DAILY_EXPLAINABILITY_INSIGHT_CLICKS: 'sendDailyExplainabilityInsightClicks',
    UPLOAD_DUMP_FILES: 'uploadDumpFiles',
    PRODUCT_PAS: 'productDataPas',
    SEND_PRODUCT_DATA_TIERS_STATISTIC: 'sendProductDataTiersStatistic',
    CALCULATE_STATISTICS_WEEKLY: 'calculateStatisticsWeekly',
    CALCULATE_STATISTICS_DAILY: 'calculateStatisticsDaily',
    CALCULATE_STATISTICS_HOURLY: 'calculateStatisticsHourly',
    GET_INTEGRATIONS_CONF_CONFIGURATION_FROM_RAVEN: 'getIntegrationsConfFromRaven',
    TEST_ALL_INTEGRATION_CONFIGURATIONS: 'testAllIntegrationConfigurations',
    ALIGN_INTEGRATIONS_CONFIG: 'alignIntegrationsConfig',
    PRODUCT_DAILY_ACCESS_ANALYSIS: 'productDailyAccessAnalysis',
    REFRESH_ACCESS_ANALYSIS: 'refreshAccessAnalysis',
    SERVICE_ACCOUNT_OWNER_SYNC: 'serviceAccountOwnerSync',
    BUILD_ACTIVE_WALLS_LIST: 'buildActiveWallsList',
    REFRESH_DASHBOARD_DATA: 'refreshDashboardData',
    CHECK_EXCLUDE_TILL_EXPIRE: 'checkExcludeTillExpire',
    PRODUCT_DAILY_USER_MANAGEMENT_GENERAL_DATA: 'productDailyUserManagementGeneralData',
    PRODUCT_DAILY_USER_MANAGEMENT_TOKENS_DATA: 'productDailyUserManagementTokensData',
    PRODUCT_DAILY_USER_MANAGEMENT_SETTINGS_DATA: 'productDailyUserManagementSettingsData',
    SYNC_LOCAL_ACCOUNTS: 'syncLocalAccounts',
    SYNC_POLICY_TEMPLATES_FROM_CLOUD: 'syncPolicyTemplatesFromCloud',
    CHECK_NEW_VERSION: 'checkNewVersion',
    RESOURCES_MFA_ENFORCEMENT_TASK: 'resourcesMfaEnforcementTask',
    PG_LIMIT_ENFORCEMENT: 'pgLimitEnforcement',
    SYNC_MFA_PROVIDERS_FROM_CLOUD: 'syncMfaProvidersFromCloud',
    PROTECTION_GROUPS_LOG_BITMAPS_STATS: 'ProtectionGroupsLogBitmapsStats'
};

exports.ELASTIC_STATISTICS_IDS = {
    AVERAGE_MFA_PER_USER: 'averageMfaPerUser',
    MAX_MFA_PER_USER: 'maxMfaPerUser',
    MFA_PER_USER: 'mfaPerUser',
    AUTH_COUNT_BY_PROTOCOL: 'authCountByProtocol',
    AUTH_COUNT_BY_RISK_LEVEL: 'authCountByRiskLevel',
    AUTH_COUNT_BY_MFA_RESPONSE: 'authCountByMfaResponse',
    USERS_COUNT_BY_RISK: 'usersCountByRiskLevel',
    APPLICATION_COUNT_BY_PROTOCOL: 'applicationCountByProtocol',
    POLICIES_COUNT: 'policiesCount',
    PROTECTED_ACCOUNT_USERS: 'protectedAccountsUsers',
    PROTECTED_ACCOUNT_ADMIN_USERS: 'protectedAccountsAdminUsers',
    PROTECTED_ACCOUNT_PRIVILEGED_USERS: 'protectedAccountsyPrivilegedUsers',
    SERVICE_ACCOUNT_BRUTE_FORCE: 'serviceAccountsBruteForceCount',
    DORMANT_SERVICE_ACCOUNT: 'dormantServiceAccountsCount',
    HIGHLY_PRIVILEGED_SERVICE_ACCOUNT: 'highlyPrivilegedServiceAccountsCount',
    CRITICAL_SERVICE_ACCOUNT: 'criticalServiceAccounts',
    SERVICE_ACCOUNT_INTERACTIVE_LOGIN: 'serviceAccountsInteractiveLoginCount',
    PROTECTED_SERVICE_ACCOUNT: 'protectedServiceAccountsCount',
    ALL_SERVICE_ACCOUNT: 'allServiceAccountsCount',
    DISCOVERED_SERVICE_ACCOUNT: 'DiscoveredServiceAccountsCount',
    POLICY_COUNT_BY_ACTION: 'policiesCountByAction',
    SERVICE_ACCOUNT_ACCESSED_BY_ADMIN_USER: 'serversAccusedByAdmin',
    SERVICE_ACCOUNT_ACCESSED_BY_PRIVILEGED_USER: 'serversAccessedByPrivileged',
    TOP_USER_AUTH: 'topUsersAuth',
    TOP_SERVERS_AUTH: 'topServersAuth',
    IP_ADDRESSES_AUTH_BY_PROTOCOL: 'iPAddressesAuthByProtocol',
    USERS_AUTH_BY_PROTOCOL: 'usersAuthByProtocol',
    SERVERS_AUTH_BY_PROTOCOL: 'serversAuthByProtocol',
    SERVERS_ACCESSED_BY_SERVICE_AND_PROTOCOL: 'serversAccessedServiceAnd',
    HOURLY_AUTHENTICATION_METRICS: 'hourlyAuthenticationMetrics'
};

exports.AD_SYNC_MESSAGE_TYPES = {
    AD_SYNC_START: 'ADSyncStart',
    RELYING_PARTIES_UPDATE: 'RelyingPartiesUpdate',
    CUSTOM_SPNS_UPDATE: 'CustomSpnsUpdate',
    RESET_ACCOUNT_MATCHING: 'ResetAccountMatching',
    ACCOUNT_MATCHING_UPDATED: 'AccountMatchingUpdated',
    SYNC_LOCAL_ACCOUNTS: 'SyncLocalAccounts',
    LOCAL_ACCOUNTS_BINDS_UPDATED: 'LocalAccountsBindsUpdated'
};

exports.CORE_MESSAGE_TYPES = {
    NOTIFY_AD_SYNC: 'NotifyADSync',
    NOTIFY_SHADOW_ADMINS: 'NotifyShadowAdmins',
    NOTIFY_RECOVER_NODES: 'NotifyRecoverNodes',
    NOTIFY_POWER_UP_NODES: 'NotifyPowerUpNodes',
    NOTIFY_SHUTDOWN_NODES: 'NotifyShutdownNodes',
    NOTIFY_RESTART_NODES: 'NotifyRestartNodes',
    NOTIFY_RESTART_CONNECTIVITY: 'NotifyRestartConnectivity',
    NOTIFY_RECOVER_DCS: 'NotifyRecoverDCs',
    NOTIFY_TEST_ACCOUNT: 'NotifyTestAccount',
    NOTIFY_TEST_MFA_TOKEN: 'NotifyTestMFAToken',
    NOTIFY_CREATE_LOG_FILE: 'NotifyCreateLogFile',
    NOTIFY_CREATE_DC_LOG_FILE: 'NotifyCreateDCLogFile',
    NOTIFY_CONFIG_UPDATED: 'NotifyConfigUpdated',
    NOTIFY_CERTIFICATE_UPDATED: 'NotifyCertificateUpdated',
    NOTIFY_DOMAIN_LDAPS_CERTIFICATE_UPDATED: 'NotifyDomainLDAPSCertificateUpdated',
    NOTIFY_DC_CERTIFICATE_UPDATED: 'NotifyDCCertificateUpdated',
    NOTIFY_TOKENS_CHANGED: 'NotifyTokensChange',
    NOTIFY_CREATE_DC_CAPTURE_FILE: 'NotifyStartPacketCapture',
    NOTIFY_REBALANCE_AZ: 'NotifyBalanceAz',
    NOTIFY_CHECK_DELETED_GUIDS: 'notifyCheckDeletedGuids',
    DELETE_AD_CONNECTOR: 'DeleteAdConnector'
};

exports.JORAH_NOTIFICATION_STRINGS = {
    AD_SYNC_FINISHED: 'adSyncFinished',
    SHADOW_ADMIN_FINISHED: 'shadowAdminsUpdateFinished',
    RISK_AD_SYNC_FINISHED: 'riskADSyncFinished',
    AZURE_AD_SYNC_FINISHED: 'azureADSyncFinished',
    CUSTOM_INSIGHTS_CHANGED: 'customInsightsChanged'
};

exports.INCIDENTS_MESSAGE_TYPES = {
    GET_INCIDENTS: 'GetIncidents',
    END_INCIDENT: 'EndIncident'
};

exports.STUNNEL_IGNORED_PORTS = ['2220'];
exports.ARYA_PREFIX = 'arya-stun_';
exports.DISPLAY_NAME_SEPARATOR = '___';

exports.SYNC_TYPES = {
    NEW_DATA: 'new_data',
    RISK: 'risk',
    AZURE: 'azure',
    OKTA: 'okta',
    VERIFY_DELETED_ENTITIES: 'verify_deleted_entities'
};

exports.CACHE_KEYS = {
    USERS: 'users',
    DELETED_USERS: 'deleted_users',
    USERS_WITH_SPN: 'users_with_spn',
    DELETED_USERS_WITH_SPN: 'deleted_users_with_spn',
    SERVERS: 'servers',
    ENTITIES_MEMBERSHIPS: 'entities_memberships',
    DELETED_SERVERS: 'deleted_servers',
    GROUPS: 'groups',
    DELETED_GROUPS: 'deleted_groups',
    GROUPS_MEMBERSHIPS: 'groups_memberships', // TODO: remove in v4.9
    OUS: 'ous',
    DELETED_OUS: 'deleted_ous',
    OUS_MEMBERSHIPS: 'ous_memberships', // TODO: remove in v4.9
    SITES: 'sites',
    SUBNETS: 'subnets',
    DOMAIN: 'domain',
    DELETED_ENTITIES: 'deleted_entities',
    DELETED_MEMBERSHIPS: 'deleted_memberships',
    MISSING_PARENT_MEMBERSHIPS: 'missing_parent_memberships',
    MISSING_CHILD_MEMBERSHIPS: 'missing_child_memberships',
    USER_IDENTIFIERS: 'user_identifiers'
};

exports.STATISTICS_INDEX = {
    NAME: 'statistics',
    READ_ALIAS: 'statistics-read',
    WRITE_ALIAS: 'statistics-write'
};

exports.AUTHENTICATIONS_INDEX = {
    NAME: 'authentications',
    READ_ALIAS: 'authentication-logs',
    WRITE_ALIAS: 'authentication-logs-write'
};

exports.AUTHENTICATIONS_HITS_INDEX = {
    NAME: 'authentication-hits',
    READ_ALIAS: 'authentication-hits-logs',
    WRITE_ALIAS: 'authentication-hits-logs-write'
};

exports.RISK_CHANGES_INDEX = {
    NAME: 'risk-changes',
    READ_ALIAS: 'risk-changes-read',
    WRITE_ALIAS: 'risk-changes-write'
};
exports.JIT_ACTIONS_INDEX = {
    NAME: 'jit-actions',
    READ_ALIAS: 'jit-actions-read',
    WRITE_ALIAS: 'jit-actions-write'
};

exports.INCIDENT_CHANGES_INDEX = {
    NAME: 'incident-changes',
    READ_ALIAS: 'incident-changes-read',
    WRITE_ALIAS: 'incident-changes-write'
};

// Will be removed under AF-40090
exports.INCIDENTS_INDEX = {
    NAME: 'incidents',
    READ_ALIAS: 'incidents-logs',
    WRITE_ALIAS: 'incidents-logs-write'
};

exports.INCIDENTS_LOGS_INDEX = {
    NAME: 'incidents-auth-logs',
    READ_ALIAS: 'incidents-auth-logs-read',
    WRITE_ALIAS: 'incidents-auth-logs-write'
};

exports.INCIDENTS_AGGREGATIONS_INDEX = {
    NAME: 'incidents-aggregations',
    READ_ALIAS: 'incidents-aggregations-read',
    WRITE_ALIAS: 'incidents-aggregations-write'
};

exports.INCIDENTS_AGGREGATIONS_TRANSFORMS_ID = 'incidents-aggregations-transforms';

exports.DCS_STATUS_INDEX = {
    NAME: 'dcs_status',
    READ_ALIAS: 'dcs-status-read',
    WRITE_ALIAS: 'dcs-status-write'
};

exports.NODES_STATES = {
    STANDBY: {
        ID: 0,
        TEXT: 'standby',
        DISPLAY: 'Standby'
    },
    ACTIVE: {
        ID: 1,
        TEXT: 'active',
        DISPLAY: 'Active'
    },
    ACTIVE_WITH_INCIDENTS: {
        ID: 2,
        TEXT: 'has_incidents',
        DISPLAY: 'Active with issues'
    },
    STARTING: {
        ID: 3,
        TEXT: 'starting',
        DISPLAY: 'Starting...'
    },
    STOPPING: {
        ID: 4,
        TEXT: 'stopping',
        DISPLAY: 'Stopping...'
    },
    UNREACHABLE: {
        ID: 5,
        TEXT: 'unreachable',
        DISPLAY: 'Unreachable'
    }
};

exports.AD_CONNECT_STATUSES = {
    UNREACHABLE: 'Unreachable',
    PROCESSING: 'Processing',
    ACTIVE: 'Active'
};

exports.AD_ENTITY_TYPES = {
    USER: 1,
    GROUP: 2,
    OU: 3,
    HOST: 4,
    SERVER: 5,
    IP: 6,
    APPLICATION: 7,
    OKTA: 8,
    LOCAL_ACCOUNT: 9
};
exports.AD_ENTITY_TYPES_NAMES = {
    1: 'User',
    2: 'Group',
    3: 'OU'
};

exports.CHART_COLORS = [
    '#FBDF40',
    '#FF115B',
    '#50017A',
    '#1C89AC',
    '#F1BBCF',
    '#FFAF39',
    '#BF1052',
    '#C9DDE3',
    '#D6C7DD',
    '#FFEACB',
    '#FFEA56',
    '#77017A',
    '#80517A',
    '#FCDF90'
];

exports.AD_ENTITY_TYPE_TO_NAME = {
    [this.AD_ENTITY_TYPES.USER]: 'User',
    [this.AD_ENTITY_TYPES.GROUP]: 'Group',
    [this.AD_ENTITY_TYPES.OU]: 'OU',
    [this.AD_ENTITY_TYPES.HOST]: 'Host',
    [this.AD_ENTITY_TYPES.SERVER]: 'Server',
    [this.AD_ENTITY_TYPES.IP]: 'IP',
    [this.AD_ENTITY_TYPES.APPLICATION]: 'Application',
    [this.AD_ENTITY_TYPES.OKTA]: 'Okta'
};

exports.SHADOW_ADMINS_ENTITIES_EXTERNAL_TYPES = {
    UNDEFINED: 0,
    DOMAIN: 9
};

exports.SHADOW_ADMIN_ENTITY_TYPES_NAMES = {
    [this.SHADOW_ADMINS_ENTITIES_EXTERNAL_TYPES.UNDEFINED]: 'N/A',
    [this.AD_ENTITY_TYPES.USER]: 'User',
    [this.AD_ENTITY_TYPES.GROUP]: 'Group',
    [this.AD_ENTITY_TYPES.OU]: 'OU',
    [this.AD_ENTITY_TYPES.HOST]: 'Host',
    [this.AD_ENTITY_TYPES.SERVER]: 'Server',
    [this.AD_ENTITY_TYPES.IP]: 'IP',
    [this.AD_ENTITY_TYPES.APPLICATION]: 'Application',
    [this.AD_ENTITY_TYPES.OKTA]: 'Okta',
    [this.SHADOW_ADMINS_ENTITIES_EXTERNAL_TYPES.DOMAIN]: 'Domain'
};

exports.AUTHENTICATION_LOG_REASONS = {
    RULE_ACTION: {
        NAME: 'rule',
        USER_RESPONSE: ''
    },
    NOT_PAIRED_USER: {
        NAME: 'non-paired-user',
        USER_RESPONSE: 'unpaired',
        DISPLAY: 'Unpaired'
    },
    NOT_PROTECTED_USER: {
        NAME: 'non-protected-user',
        USER_RESPONSE: 'unprotected',
        DISPLAY: 'Unprotected'
    },
    NO_RULE: {
        NAME: 'no-rule',
        USER_RESPONSE: ''
    },
    RULE_NOT_APPLIED: {
        NAME: 'rule-not-applied',
        USER_RESPONSE: ''
    },
    EXCLUDED_USER: {
        NAME: 'user-excluded',
        USER_RESPONSE: 'user-excluded',
        DISPLAY: 'Excluded user'
    },
    SAME_TIME_WINDOW: {
        NAME: 'time-window',
        USER_RESPONSE: 'automatic',
        DISPLAY: 'Auto-response',
        DESC: 'User approved/denied MFA request and immediately after that performed another MFA. In that case, we will respond automatically based on the user’s first MFA.'
    },
    TIMEOUT: {
        NAME: 'timeout',
        USER_RESPONSE: 'timeout',
        DISPLAY: 'Timed out',
        TEST_PASSED: false
    },
    USER_APPROVED_MFA: {
        NAME: 'user-approved-mfa',
        USER_RESPONSE: 'true',
        DISPLAY: 'Approved',
        TEST_PASSED: true
    },
    USER_DENIED_MFA: {
        NAME: 'user-denied-mfa',
        USER_RESPONSE: 'false',
        DISPLAY: 'Blocked',
        TEST_PASSED: true
    },
    AUTO_BLOCKED: {
        NAME: 'auto-deny',
        USER_RESPONSE: 'auto-deny',
        DISPLAY: 'Auto-blocked'
    },
    INVALID_TOKEN: {
        NAME: 'invalid-token',
        USER_RESPONSE: 'invalid-token',
        DISPLAY: 'Invalid token'
    },
    NO_RELEVANT_TOKENS: {
        NAME: 'no-relevant_tokens',
        USER_RESPONSE: 'no-relevant_tokens',
        DISPLAY: 'No relevant device'
    },
    CANT_SEND_MFA: {
        NAME: 'cant-send-mfa',
        USER_RESPONSE: 'cant-send-mfa',
        DISPLAY: 'Not available'
    },
    SAME_GROUP: {
        NAME: 'same-group',
        USER_RESPONSE: 'same-group',
        DISPLAY: 'Auto-response',
        DESC: 'User already approved/denied an MFA request from the same group as this MFA. In that case, we will respond automatically based on the user’s first MFA.'
    },
    INVALID_OTP: {
        NAME: 'invalid-otp',
        USER_RESPONSE: 'invalid-otp',
        DISPLAY: 'Invalid OTP'
    },
    FAIL_OPEN: {
        NAME: 'fail-open',
        USER_RESPONSE: 'fail-open',
        DISPLAY: 'Fail open'
    },
    FAIL_CLOSE: {
        NAME: 'fail-close',
        USER_RESPONSE: 'fail-close',
        DISPLAY: 'Fail close'
    },
    MISSING_MFA_USER_BINDING: {
        NAME: 'missing-mfa-user-binding',
        USER_RESPONSE: 'missing-mfa-user-binding',
        DISPLAY: 'Unbound'
    },
    INVALID_MFA_USER_SELECTION: {
        NAME: 'invalid-mfa-user-selection',
        USER_RESPONSE: 'invalid-mfa-user-selection',
        DISPLAY: 'Invalid user selection'
    }
};

exports.EXTERNAL_MFA_PROVIDERS = {
    OKTA: 'okta',
    RSA: 'rsa',
    DUO: 'duo',
    PING: 'ping',
    MICROSOFT: 'microsoft',
    PING_ADAPTER: 'ping_adapter',
    HYPR: 'hypr',
    CUSTOM_MFA: 'custom_mfa'
};

exports.USER_TYPES = {
    REGULAR: 1,
    MACHINE_ACCOUNT: 2,
    SERVICE_ACCOUNT: 3
};

exports.SERVER_TYPE = {
    NODE: 1,
    DC: 2,
    TOWER: 3,
    LDAPS: 4,
    ARYA: 5,
    SSO: 6,
    DOMAIN_ROOT_CA: 7
};

exports.GUID_SEARCH_KEY_TYPES = {
    DN: 'dn',
    UPN: 'identifier',
    SAM: 'sam',
    NAME: 'name'
};

exports.GUID_SEARCH_KEY_TYPES_MAX_LENGTH = {
    DN: 2048,
    UPN: 1024,
    SAM: 20,
    NAME: 64
};

exports.GUID_SEARCH_OBJECT_KEYS = {
    USER: this.AD_ENTITY_TYPES.USER,
    GROUP: this.AD_ENTITY_TYPES.GROUP,
    COMPUTER: this.AD_ENTITY_TYPES.SERVER,
    OU: this.AD_ENTITY_TYPES.OU
};

exports.RISK_INDICATORS_SOURCES = {
    SERVICE_ACCOUNTS_API: 'sa_api'
};

exports.RISK_INDICATORS_ENTITIES_TYPE = {
    USER: 'user'
};

exports.SERVICE_ACCOUNT_ACTIONS = {
    BLOCK: { ID: 'block', DISPLAY: 'Deny Access' },
    SEND_TO_SIEM: { ID: 'siem', DISPLAY: 'Send to SIEM' },
    LOG: { ID: 'log', DISPLAY: 'Notify', MANDATORY: true }
};

exports.PROTECTED_MODE = {
    MANUAL: 1,
    BY_SMART_POLICY: 2
};

exports.UPDATE_SA_POLICY_API_FIELDS = {
    ENABLED: 'ENABLED',
    ALLOW_ALL_DESTINATIONS: 'ALLOW_ALL_DESTINATIONS',
    ALLOW_ALL_SOURCES: 'ALLOW_ALL_SOURCES',
    ADD_ALLOWED_SOURCES: 'ADD_ALLOWED_SOURCES',
    REMOVE_ALLOWED_SOURCES: 'REMOVE_ALLOWED_SOURCES',
    ADD_ALLOWED_DESTINATIONS: 'ADD_ALLOWED_DESTINATIONS',
    REMOVE_ALLOWED_DESTINATIONS: 'REMOVE_ALLOWED_DESTINATIONS',
    BLOCK: 'BLOCK',
    SEND_TO_SIEM: 'SEND_TO_SIEM',
    RISK_LEVEL: 'RISK_LEVEL',
    LIMIT_INTERACTIVE_LOGIN: 'LIMIT_INTERACTIVE_LOGIN',
    PROTOCOLS: 'PROTOCOLS'
};

exports.UPDATE_SA_POLICY_API_FIELDS_V2 = {
    ENABLED: 'enabled',
    ALLOW_ALL_DESTINATIONS: 'allow_all_destinations',
    ALLOW_ALL_SOURCES: 'allow_all_sources',
    ADD_ALLOWED_SOURCES: 'add_allowed_sources',
    REMOVE_ALLOWED_SOURCES: 'remove_allowed_sources',
    ADD_ALLOWED_DESTINATIONS: 'add_allowed_destinations',
    REMOVE_ALLOWED_DESTINATIONS: 'remove_allowed_destinations',
    BLOCK: 'block',
    SEND_TO_SIEM: 'send_to_siem',
    RISK_LEVEL: 'risk_level',
    LIMIT_INTERACTIVE_LOGIN: 'limit_interactive_login',
    PROTOCOLS: 'protocols'
};

exports.GET_SA_POLICY_API_FIELDS = {
    ...this.UPDATE_SA_POLICY_API_FIELDS,
    ALERT: 'ALERT'
};

exports.GET_SA_POLICY_API_FIELDS_V2 = {
    ...this.UPDATE_SA_POLICY_API_FIELDS_V2,
    ALERT: 'alert'
};

exports.UPDATE_SA_API_FIELDS = {
    OWNER: 'OWNER',
    OWNERS: 'OWNERS',
    CATEGORY: 'CATEGORY',
    COMMENT: 'COMMENT',
    APPLICATION: 'APPLICATION'
};

exports.CREATE_SA_API_FIELDS = {
    CATEGORY: 'CATEGORY'
};

exports.SA_API_ENTITY_KEY_TYPES = {
    GUID: 'GUID',
    IP: 'IP',
    NAME: 'NAME'
};

exports.SERVICE_ACCOUNTS_RULES_PADDING = 1000000;
exports.SERVICE_ACCOUNTS_BLOCK_RULES_PADDING = 2000000;
exports.FENCING_RULES_PADDING = 10000000;

// DEPRECATED - AF-46754: Remove this after v6.2
// should be used only in tower client
// after v6.2 the client will be supported by nx and thus "Severity" should be used from system notifications lib instead
exports.EVENT_LEVEL = {
    DEBUG: { value: 0, label: 'Debug' },
    INFO: { value: 1, label: 'Info' },
    WARNING: { value: 2, label: 'Warning' },
    ERROR: { value: 3, label: 'Error' }
};

exports.SA_POLICY_EVENT_MAX_LENGTH = 1000;

exports.RELYING_PARTIES_TYPES = {
    ADFS: { ID: 'adfs', DEFAULT_PROTOCOL: 'SAML', DISPLAY: 'ADFS' },
    PING_FED: { ID: 'pingfed', DISPLAY: 'PingFederate' }
};

exports.RETROSPECTIVE_VALIDATION_OPTIONS = {
    DISABLE: { value: 1, label: 'Disable' },
    ENABLE: { value: 2, label: 'Enable Always' },
    CONDITIONAL_ENABLE: { value: 3, label: 'Enable only on timeout and deny authentications' }
};

exports.AD_CONNECTOR_TYPE = {
    APPLICATION: 'application'
};

exports.AD_SYNC_TYPES = {
    DATA: 'data',
    RISK: 'risk',
    AZURE: 'azure',
    OKTA: 'okta'
};

exports.TEST_ACCOUNTS = {
    SERVICE_ACCOUNT: 0,
    MACHINE_ACCOUNT: 1,
    RADIUS_ACCOUNT: 2
};

exports.ADSYNC_TYPES = {
    FULL_DATA: 'StartFullADSync',
    DELTA_DATA: 'StartDeltaADSync',
    FULL_RISK: 'StartFullRiskADSync',
    DELTA_RISK: 'StartDeltaRiskADSync',
    SHADOW_ADMIN_SYNC: 'ShadowAdminSync'
};

exports.MFA_TYPES = {
    MOBILE: {
        ID: 1,
        DISPLAY_NAME: 'Silverfort Mobile',
        NAME: 'mobile'
    },
    DESKTOP_APP: {
        ID: 12,
        DISPLAY_NAME: 'Silverfort Desktop App',
        DISABLED_DISPLAY_NAME: 'Silverfort Desktop App - Deselect FIDO2 and OTP',
        NAME: 'desktop_app'
    },
    CHROME: {
        ID: 13,
        DISPLAY_NAME: 'Silverfort Chrome Extension',
        DISABLED_DISPLAY_NAME: 'Silverfort Chrome Extension - Deselect FIDO2 and OTP',
        NAME: 'chrome'
    },
    HARDWARE: {
        ID: 6,
        DISPLAY_NAME: 'FIDO2',
        DISABLED_DISPLAY_NAME: 'FIDO2 - Deselect Silverfort desktop app and Chrome extension',
        NAME: 'hardware'
    },
    OTP: {
        ID: 9,
        DISPLAY_NAME: 'OTP',
        DISABLED_DISPLAY_NAME: 'OTP - Deselect Silverfort desktop app and Chrome extension',
        NAME: 'otp'
    },
    MICROSOFT: {
        ID: 7,
        DISPLAY_NAME: 'MS Authenticator',
        NAME: 'microsoft'
    },
    OKTA: {
        ID: 3,
        DISPLAY_NAME: 'Okta Verify',
        NAME: 'okta'
    },
    DUO: {
        ID: 5,
        DISPLAY_NAME: 'Duo Mobile',
        NAME: 'duo'
    },
    RSA: {
        ID: 4,
        DISPLAY_NAME: 'RSA SecurID',
        NAME: 'rsa'
    },
    PING: {
        ID: 8,
        DISPLAY_NAME: 'PingID',
        NAME: 'ping'
    },
    HYPR: {
        ID: 15,
        DISPLAY_NAME: 'HYPR',
        NAME: 'hypr'
    },
    PING_ADAPTER: {
        ID: 10,
        DISPLAY_NAME: 'PingID (adapter)',
        NAME: 'ping_adapter'
    },
    AZURE_SSO: {
        ID: 11,
        DISPLAY_NAME: 'Azure SSO',
        NAME: 'azure_sso'
    },
    CUSTOM_MFA: {
        ID: 14,
        DISPLAY_NAME: 'Custom MFA Integration',
        NAME: 'custom_mfa'
    },
    RADIUS_OTP: {
        ID: 16,
        DISPLAY_NAME: 'RADIUS OTP',
        DISABLED_DISPLAY_NAME: 'RADIUS OTP - Choose RADIUS Auth Type and deselect all other Tokens',
        NAME: 'radius_otp'
    },
    BRIDGE_SSO: {
        ID: 17,
        DISPLAY_NAME: 'Bridge SSO',
        NAME: 'sso'
    },
    ENTRA_ID: {
        ID: 18,
        DISPLAY_NAME: 'Entra Id',
        NAME: 'entraId'
    },
    MS_TEAMS: {
        ID: 19,
        DISPLAY_NAME: 'Microsoft Teams',
        NAME: 'ms_teams',
        DISABLED_DISPLAY_NAME: 'Microsoft Teams - Deselect FIDO2 and OTP'
    }
};

exports.EXTERNAL_MFA_PROVIDER_TOKEN_NAME = 'external';

exports.OKTA_SIGNIN_APP = {
    identifier: 'okta_sign_on',
    display_name: 'Okta Sign On',
    name: 'okta_sign_on'
};

exports.DISCOVERY_APPLICATION_TYPES = {
    RDP: { label: 'RDP servers', value: 'rdp', services: ['termsrv'], redisKey: 'isRDPServer' },
    FILESHARE: { label: 'File shares', value: 'files', services: ['cifs'], redisKey: 'isFileShareServer' },
    HOSTS: { label: 'Hosts', value: 'hosts', services: ['host'], redisKey: 'isHostServer' },
    KERBEROS_WEB_SERVICES: {
        label: 'Kerberos web services',
        value: 'kws',
        services: ['http'],
        redisKey: 'isKWSServer'
    },
    RPC: { label: 'RPC servers', value: 'rpc', services: ['rpc', 'rpcss'], redisKey: 'isRPCServer' },
    DNS: { label: 'DNS servers', value: 'dns', services: ['dns'], redisKey: 'isDNSServer' },
    LDAP: { label: 'LDAP servers', value: 'ldap', services: ['ldap'], redisKey: 'isLDAPServer' },
    WEB_APPS: { label: 'Web applications', value: 'web_app', redisKey: 'isWebApp' },
    LEGACY_APPS: { label: 'Legacy applications', value: 'lagacy_app', redisKey: 'isLegacyApp' },
    LDAPS_APPS: { label: 'LDAPS applications', value: 'ldaps_app', redisKey: 'isLDAPSApp' },
    NOT_AVAILABLE: { label: 'N/A', value: 'empty', redisKey: 'not_available' }
};

exports.DIRECTORY_TYPES = {
    ad: { key: 'ad', displayName: 'Active Directory' },
    aad: { key: 'aad', displayName: 'Entra ID', settingsSection: 'Integrations#azureConnectors' },
    adfs: { key: 'adfs', displayName: 'ADFS' },
    pingfed: { key: 'pingfed', displayName: 'PingFederate' },
    radius: { key: 'radius', displayName: 'RADIUS' },
    desktop_mfa: { key: 'desktop_mfa', displayName: 'Desktop MFA' },
    okta: { key: 'okta', displayName: 'Okta' },
    local: { key: 'local', displayName: 'Local' }
};

exports.CONFIGURATIONS_KEY = 'configurations';
exports.CONFIGURATION_CHANGED_EVENT = 'ConfigurationChanged';
exports.CONFIG_INTERVAL_MS = 100;

exports.REDIS_DATABASES_NUMBERS = {
    DEFAULT: 0,
    APPLICATIONS_DISCOVERY: 1,
    AD_SYNC: 2,
    ALARMS: 3,
    CONFIGURATIONS: 4,
    RULES: 5,
    PROTECTION_GROUPS: 7,
    WALL_JOBS: 8,
    OTP: 9,
    ARYA_MFA: 10,
    REVOKED_TOKENS: 11,
    FEATURE_FLAGS: 12,
    PRIVILEGE_ACCOUNTS_TIERS: 13,
    PRIVILEGE_ACCOUNTS_TIERS_TEMP: 14,
    PAIRING_OTP_TRIES: 15
};

exports.REDIS_MASTER_DATABASES_NUMBERS = {
    LIMITS: 1,
    IDENTIFIERS: 7
};

exports.REDIS_MASTER_IDENTIFIERS_VERSION_KEY = 'identifiers_version';

exports.SECTION_NAMES_TO_ADVANCED_CONFIG_NAME = {
    jorah: 'JorahConfiguration',
    citadel: 'CitadelConfiguration',
    risk: 'RiskConfiguration',
    dumper: 'DumperConfiguration',
    authStreamer: 'AuthStreamerConfiguration'
};

exports.SECTION_NAMES_TO_ADDITIONAL_DATA = {
    dumper: ['CompanyName', 'CustomerId', 'EnvironmentId', 'DumperSendDailyAutomatically', 'DumperSendAutoAnonymized'],
    authStreamer: [
        'CompanyName',
        'CustomerId',
        'EnvironmentId',
        'DumperSendDailyAutomatically',
        'DumperSendAutoAnonymized'
    ]
};

exports.LOG_LEVEL_OPTIONS = {
    none: { value: 'none', label: 'None' },
    error: { value: 'error', label: 'Error' },
    warn: { value: 'warn', label: 'Warning' },
    info: { value: 'info', label: 'Information' },
    debug: { value: 'debug', label: 'Debug' },
    extended: { value: 'extended-debug', label: 'Trace' }
};

exports.NODE_LOG_LEVEL_OPTIONS = {
    debug: { value: 'debug', label: 'Debug' },
    info: { value: 'info', label: 'Information' },
    warn: { value: 'warn', label: 'Warning' },
    error: { value: 'error', label: 'Error' }
};

exports.ROLES = {
    ADMIN: { value: 3, label: 'Admin' },
    EDITOR: { value: 2, label: 'Editor' },
    VIEWER: { value: 1, label: 'Viewer' },
    NONE: { value: 0, label: 'None' }
};

exports.CONDITIONS_OPTIONS = {
    START_WITH: { value: 1, label: 'Starts with' },
    CONTAINS: { value: 2, label: 'Contains' },
    END_WITH: { value: 3, label: 'Ends with' }
};

exports.CONDITIONS_OPTIONS_VALUE_LABEL = {
    [this.CONDITIONS_OPTIONS.START_WITH.value]: this.CONDITIONS_OPTIONS.START_WITH.label,
    [this.CONDITIONS_OPTIONS.CONTAINS.value]: this.CONDITIONS_OPTIONS.CONTAINS.label,
    [this.CONDITIONS_OPTIONS.END_WITH.value]: this.CONDITIONS_OPTIONS.END_WITH.label
};

exports.CUSTOM_INSIGHTS_TYPES = {
    StaticCustomInsights: {
        name: 'Predefined insights',
        conditionLabel: 'Additional naming conventions'
    },
    UserCustomInsights: {
        name: 'User-defined insights',
        conditionLabel: 'Naming conventions'
    }
};

exports.STATIC_CUSTOM_INSIGHTS = {
    privileged_user_rule: 'Privileged Users',
    service_account_rule: 'Service Accounts'
};

exports.PERMISSION_NAME_MAPPER = {
    dashboard: 'Dashboard',
    policies: 'Policies',
    serviceAccounts: 'Service Accounts',
    applicationsDiscovery: 'App Discovery',
    insights: 'ISPM',
    investigation: 'Investigation',
    users: 'User Management',
    excludeUsers: 'Temporarily exclude/resume users',
    sendEnrollmentEmail: 'Send enrollment email',
    sendEnrollmentEmailToAllUnpaired: 'Send enrollment email to all unpaired users',
    manageProtectedGroups: 'Manage protected groups',
    setEmail: 'Set email',
    matchUsers: 'Match and unmatch users',
    disableToken: 'Disable token',
    deleteUserTokens: 'Delete tokens',
    testUserTokens: 'Test tokens',
    logs: 'Logs',
    systemStatus: 'Monitor - system status',
    toggleSystemPower: 'Powerup or Shutdown System',
    preformAdsync: 'Preform Adsync',
    notifications: 'Monitor - systemEvents',
    softwareUpdates: 'Monitor - software updates',
    settings: 'Settings',
    privilegedAccounts: 'Privileged Access',
    authorize: 'Authorize',
    testMFATokens: 'Test tokens',
    risk: 'ITDR',
    accessAnalysis: 'Access Analysis',
    cloudNhi: 'Cloud NHI',
    cloudIntegrations: 'Cloud Integrations',
    inventory: 'Identity Graph and Inventory',
    inventoryAd: 'Active Directory Inventory',
    inventoryCloud: 'Cloud Inventory',
    aiAgentSecurityCloud: 'Cloud AI Agents Security',
    aiAccessControlCloud: 'Cloud AI Access Control',
    accessAnalysisCloud: 'Cloud Access Analysis',
    cloudInsights: 'Cloud ISPM',
    cloudRisk: 'Cloud ITDR',
    aiAssistant: 'AI Assistant'
};

exports.CLOUD_PERMISSIONS = [
    'cloudNhi',
    'cloudIntegrations',
    'aiAgentSecurityCloud',
    'aiAccessControlCloud',
    'accessAnalysisCloud',
    'cloudInsights',
    'cloudRisk'
];

exports.LIMITED_OPTIONS_PERMISSIONS = [
    'excludeUsers',
    'deleteUserTokens',
    'testUserTokens',
    'sendEnrollmentEmail',
    'manageProtectedGroups',
    'toggleSystemPower',
    'preformAdsync',
    'authorize'
];

exports.SYSTEM_STATES = {
    STANDBY: 0,
    ACTIVE: 1
};

exports.DCS_STATES = {
    DISCONNECTED: 0,
    CONNECTED: 1,
    DISCONNECTED_WITH_INCIDENTS: 2,
    CONNECTED_WITH_INCIDENTS: 3
};

exports.PUSH_SERVICES_STATUS = {
    DISCONNECTED: 0,
    CONNECTED: 1
};

exports.NODE_TYPE = {
    WALL: 0,
    ARYA: 1,
    TOWER: 2,
    DC: 3,
    AD_CONNECT: 4
};

exports.NODE_TYPE_TO_UPGRADE_NAME = {
    [this.NODE_TYPE.WALL]: 'wall',
    [this.NODE_TYPE.ARYA]: 'arya',
    [this.NODE_TYPE.TOWER]: 'tower'
};

exports.JORAH_ENTITY_TYPES = {
    USER: 0,
    RESOURCE: 2
};
exports.INVESTIGATION_USER_TYPES = {
    AD: 'AD',
    ENTRA: 'Entra',
    HYBRID: 'Hybrid'
};

exports.INVESTIGATION_DRAWER_ENTITY_TYPES = {
    USER: {
        adType: 1,
        urlData: '/investigate/User'
    },
    DEVICE: {
        adType: 4,
        urlData: '/investigate/Resource'
    },
    RESOURCE: {
        adType: 5,
        urlData: '/investigate/Resource'
    },
    GROUP: {
        adType: 2,
        urlData: '/investigate/Group'
    },
    OU: {
        adType: 3,
        urlData: '/investigate/OU'
    }
};

exports.INVESTIGATION_ENTITY_TYPES = {
    RISK: {
        id: -1
    },
    USER: {
        id: 0,
        urlPrefix: '/Investigation/Users/',
        urlData: '/investigate/User',
        investigateUrl: 'user'
    },
    DEVICE: {
        id: 1,
        urlPrefix: '/Investigation/Resources/',
        urlData: '/investigate/Resource',
        investigateUrl: 'resource'
    },
    RESOURCE: {
        id: 2,
        urlPrefix: '/Investigation/Resources/',
        urlData: '/investigate/Resource',
        investigateUrl: 'resource'
    },
    APPLICATION: {
        id: 3,
        urlPrefix: '/Investigation/Applications/',
        urlData: '/investigate/Application',
        investigateUrl: 'application'
    },
    OKTA: {
        id: 4,
        urlPrefix: '/Investigation/Okta/',
        urlData: '/investigate/Okta',
        investigateUrl: 'okta'
    },
    INCIDENT: {
        id: 5,
        urlPrefix: '/Investigation/Incidents/',
        urlData: '/incidents/getIncidentFullData',
        investigateUrl: 'incident'
    }
};

exports.AD_RESOURCES_TYPES = {
    SERVER: 1,
    USER_WITH_SPN: 2
};

exports.RISK_CHANGE_TYPE = {
    LEVEL_CHANGE: 1,
    INDICATOR_CHANGE: 2
};

exports.ACTIVITY_TYPES = {
    RISK_CHANGE: 1,
    AUTH_LOG: 2,
    INCIDENT_CHANGE: 3,
    JIT_ACTION: 4,
    EVENTS_LOG: 5
};

exports.POLICY_ACTION_TYPES = {
    ALLOW: { value: 1, title: 'Allow', orderType: 'state', label: 'ALLOW' },
    DENY: {
        value: 2,
        title: 'Deny',
        orderType: 'state',
        moreInfo: 'Policies with Deny action will be executed after Allow',
        label: 'DENY'
    },
    MFA: {
        value: 3,
        title: 'MFA',
        orderType: 'priority',
        moreInfo: 'Policies with MFA action will be executed after Allow & Deny',
        label: 'MFA'
    },
    NOTIFY: {
        value: 4,
        title: 'Notify',
        orderType: 'state',
        moreInfo: 'Policies with Notify action will be executed after Allow, Deny & MFA',
        label: 'NOTIFY'
    },

    BRIDGE: {
        value: 5,
        title: 'Identity Bridge',
        orderType: 'priority',
        moreInfo: 'Policies with Bridge action will be executed after Allow & Deny',
        label: 'IDENTITY BRIDGE'
    },

    NEW: { value: 0, title: 'New policy', orderType: 'state' }
};

exports.ENTITY_ACTIVITIES_FILTERS_OPTIONS = {
    RISK: { value: 'riskChanges', label: 'Risk changes' },
    AUTHENTICATIONS: { value: 'authentication', label: 'Authentications' },
    INCIDENT_CHANGES: { value: 'incidentChanges', label: 'Status changes' },
    JIT_ACTION: { value: 'jitActions', label: 'Jit actions' },
    EVENTS_LOG: { value: 'eventsLog', label: 'Events Log' }
};

exports.RISK_LEVELS = {
    LOW: { value: 1, label: 'low' },
    MEDIUM: { value: 2, label: 'medium' },
    HIGH: { value: 3, label: 'high' },
    CRITICAL: { value: 4, label: 'critical' }
};

exports.PLATFORMS = {
    AZURE: 'Azure',
    ACTIVE_DIRECTORY: 'Active Directory'
};

exports.SERVICE_ACCOUNT_POLICY_API_RISK_LEVEL = {
    LOW: this.RISK_LEVELS.LOW.label,
    MEDIUM: this.RISK_LEVELS.MEDIUM.label,
    HIGH: this.RISK_LEVELS.HIGH.label,
    ALL: 'all'
};

exports.SERVICE_ACCOUNT_POLICY_API_RISK_LEVEL_V2 = {
    ALL: 'All'
};

exports.RISK_INDICATORS_SELECTION_TYPE = {
    ANY: { value: 1, label: 'When ANY of the following are detected' },
    ALL: { value: 2, label: 'When ALL of the following are detected' }
};

exports.REQUIRE_MFA_FROM_TYPES = {
    LAST_SUCCESSFUL_MFA: { value: false, label: 'last successful MFA' },
    LAST_SUCCESSFUL_AUTHENTICATION: {
        value: true,
        label: 'last successful authentication'
    }
};

exports.AUTH_PROTOCOL_OPTIONS = [
    { value: 'AAD SSO', label: 'Entra ID SSO' },
    { value: 'Kerberos', label: 'Kerberos' },
    { value: 'LDAP', label: 'LDAP' },
    { value: 'LDAPS', label: 'LDAPS' },
    { value: 'NTLM', label: 'NTLM' },
    { value: 'OIDC', label: 'OIDC' },
    { value: 'Okta SSO', label: 'Okta SSO' },
    { value: 'RADIUS', label: 'RADIUS' },
    { value: 'SAML', label: 'SAML' },
    { value: 'API', label: 'Silverfort API' }
];

exports.PROTOCOL_DISPLAY_MAPPER = {
    kerberos: 'Kerberos',
    ntlm: 'NTLM',
    ldap: 'LDAP',
    ldaps: 'LDAPS',
    desktop: 'Desktop',
    radius: 'RADIUS',
    saml: 'SAML'
};

exports.AUTH_TYPES_TO_SHOW = {
    AD_KERBEROS: {
        protocols: ['KERBEROS'],
        label: 'AD - Kerberos'
    },
    AD_NTLM: {
        protocols: ['NTLM'],
        label: 'AD - NTLM'
    },
    AD_LDAP: {
        protocols: ['LDAP'],
        label: 'AD - LDAP'
    },
    AD_LDAPS: {
        protocols: ['LDAPS'],
        label: 'AD - LDAPS'
    },
    AZURE_ACTIVE_DIRECTORY: {
        protocols: ['AAD SSO', 'OIDC'],
        label: 'Microsoft Entra ID',
        short_label: 'Entra ID'
    },
    'OKTA SSO': {
        protocols: [],
        label: 'Okta SSO',
        short_label: 'Okta'
    },
    PING_ADAPTER: {
        protocols: [],
        label: 'PingFederate'
    },
    RADIUS: {
        protocols: [],
        label: 'RADIUS'
    },
    DESKTOP: {
        protocols: [],
        label: 'Windows Logon'
    },
    API: {
        protocols: [],
        label: 'Silverfort API'
    },
    SAML: {
        protocols: ['SAML'],
        label: 'SAML'
    }
};

exports.NTLMV1 = 'NTLMV1';

exports.PROTOCOL_DISPLAY_NAMES = {
    KERBEROS: 'Kerberos',
    NTLM: 'NTLM',
    LDAP: 'LDAP',
    LDAPS: 'LDAPS',
    OIDC: 'OIDC',
    RADIUS: 'RADIUS',
    SAML: 'SAML',
    API: 'Silverfort API',
    'AAD SSO': 'Entra ID SSO',
    'OKTA SSO': 'Okta SSO',
    PING_ADAPTER: 'PingFederate',
    ADFS: 'ADFS',
    DESKTOP: 'Windows Logon'
};

exports.NTLM_V1 = 'NTLMV1';

exports.SERVICE_ACCOUNTS_PROTOCOLS_COLUMNS = {
    [this.PROTOCOL_DISPLAY_NAMES.KERBEROS]: `last_use_${this.PROTOCOL_DISPLAY_NAMES.KERBEROS.toLowerCase()}`,
    [this.PROTOCOL_DISPLAY_NAMES.NTLM]: `last_use_${this.PROTOCOL_DISPLAY_NAMES.NTLM.toLowerCase()}`,
    [this.PROTOCOL_DISPLAY_NAMES.LDAP]: `last_use_${this.PROTOCOL_DISPLAY_NAMES.LDAP.toLowerCase()}`,
    [this.PROTOCOL_DISPLAY_NAMES.LDAPS]: `last_use_${this.PROTOCOL_DISPLAY_NAMES.LDAPS.toLowerCase()}`
};

exports.PROTECTED_PROTOCOL_LAST_USE_FIELDS = {
    [this.PROTOCOL_DISPLAY_NAMES.KERBEROS]: [
        this.SERVICE_ACCOUNTS_PROTOCOLS_COLUMNS[this.PROTOCOL_DISPLAY_NAMES.KERBEROS]
    ],
    [this.PROTOCOL_DISPLAY_NAMES.NTLM]: [this.SERVICE_ACCOUNTS_PROTOCOLS_COLUMNS[this.PROTOCOL_DISPLAY_NAMES.NTLM]],
    [this.PROTOCOL_DISPLAY_NAMES.LDAP]: [
        this.SERVICE_ACCOUNTS_PROTOCOLS_COLUMNS[this.PROTOCOL_DISPLAY_NAMES.LDAP],
        this.SERVICE_ACCOUNTS_PROTOCOLS_COLUMNS[this.PROTOCOL_DISPLAY_NAMES.LDAPS]
    ]
};

exports.SERVICE_ACCOUNTS_PROTOCOLS_OPTIONS = {
    KERBEROS: {
        label: 'Kerberos',
        value: this.PROTOCOL_DISPLAY_NAMES.KERBEROS
    },
    NTLM: {
        label: 'NTLM',
        value: this.PROTOCOL_DISPLAY_NAMES.NTLM
    },
    LDAP: {
        label: 'LDAP/S',
        value: this.PROTOCOL_DISPLAY_NAMES.LDAP,
        tooltip: 'LDAP protocol enforcement is based on the IP addresses listed in the DESTINATION column'
    }
};

exports.PROTOCOLS_GRAPHS_COLORS = {
    AD: 'rgba(24, 141, 237, 0.9)',
    AD_KERBEROS: 'rgba(24, 141, 237, 0.9)',
    AZURE_ACTIVE_DIRECTORY: 'rgba(49, 193, 120, 0.9)',
    KERBEROS: 'rgba(24, 141, 237, 0.9)',
    AD_NTLM: 'rgba(241, 32, 241, 0.9)',
    NTLM: 'rgba(241, 32, 241, 0.9)',
    RADIUS: 'rgba(132, 130, 130, 0.9)',
    OIDC: 'rgba(252, 230, 81, 0.9)',
    AD_LDAP: 'rgba(241, 32, 71, 0.9)',
    LDAP: 'rgba(241, 32, 71, 0.9)',
    AD_LDAPS: 'rgba(252, 230, 81, 0.9)',
    LDAPS: 'rgba(252, 230, 81, 0.9)',
    SAML: 'rgba(255, 255, 255, 0.9)',
    API: 'rgba(255, 91, 0, 0.9)',
    DESKTOP: 'rgba(128, 128, 0, 0.9)',
    PING_ADAPTER: 'rgba(138, 68, 218, 0.9)',
    'AAD SSO': 'rgba(0, 128, 128, 0.9)',
    'OKTA SSO': 'rgba(68, 218, 173, 0.9)',
    OTHER: 'rgba(202, 202, 202, 0.9)'
};

exports.MAX_SA_COMMENT_LENGTH = 140;
exports.MAX_SA_APPLICATION_LENGTH = 1024;

exports.SYSLOG_MSG_TYPES = {
    AUDIT: { value: 1, label: 'Audit' },
    AUTH: { value: 2, label: 'All Authentications' },
    MFA: { value: 3, label: 'MFA' },
    SERVICE_ACCOUNTS: { value: 4, label: 'Service Accounts Violations' },
    DAILY_INSIGHTS: { value: 5, label: 'Daily Exposures' },
    DIFF_INSIGHTS: { value: 6, label: 'Exposures Diff' },
    SETTINGS: { value: 7, label: 'Settings' },
    SPLUNK: { value: 8, label: 'Splunk Application' },
    NEW_INCIDENT: { value: 9, label: 'New incident' },
    NTLM_AUTH: { value: 10, label: 'NTLM' },
    KERB_AUTH: { value: 11, label: 'Kerberos' },
    LDAP_AUTH: { value: 12, label: 'LDAP/S' },
    AAD_SSO_AUTH: { value: 13, label: 'Entra ID SSO' },
    OCTA_SSO_AUTH: { value: 14, label: 'Okta SSO' },
    RADIUS_AUTH: { value: 15, label: 'RADIUS' },
    SAML_AUTH: { value: 16, label: 'SAML' },
    OIDC_AUTH: { value: 17, label: 'OIDC' },
    DESKTOP_AUTH: { value: 18, label: 'Desktop' },
    SF_API_AUTH: { value: 19, label: 'Silverfort API' },
    SERVICE_ACCOUNT_AUTH: { value: 20, label: 'Service Accounts Authentications' },
    POLICY_MATCH: { value: 21, label: 'Policy Match' },
    RISK_LEVEL: { value: 22, label: 'Risk Level Change' },
    NOTIFICATIONS: { value: 23, label: 'Notifications' },
    PRIVILEGED_ACCOUNTS: { value: 24, label: 'Virtual Fencing Violation' },
    INCIDENT_AUTH_LOGS: { value: 25, label: 'Incident Auth Logs' }
};

exports.PROTOCOL_TO_SYSLOG_MSG_TYPE = {
    [this.PROTOCOL_DISPLAY_NAMES.NTLM]: this.SYSLOG_MSG_TYPES.NTLM_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.KERBEROS]: this.SYSLOG_MSG_TYPES.KERB_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.LDAP]: this.SYSLOG_MSG_TYPES.LDAP_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.LDAPS]: this.SYSLOG_MSG_TYPES.LDAP_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES['AAD SSO']]: this.SYSLOG_MSG_TYPES.AAD_SSO_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES['OKTA SSO']]: this.SYSLOG_MSG_TYPES.OCTA_SSO_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.RADIUS]: this.SYSLOG_MSG_TYPES.RADIUS_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.SAML]: this.SYSLOG_MSG_TYPES.SAML_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.OIDC]: this.SYSLOG_MSG_TYPES.OIDC_AUTH.value,
    Desktop: this.SYSLOG_MSG_TYPES.DESKTOP_AUTH.value,
    [this.PROTOCOL_DISPLAY_NAMES.API]: this.SYSLOG_MSG_TYPES.SF_API_AUTH.value,
    API: this.SYSLOG_MSG_TYPES.SF_API_AUTH.value
};

exports.PLATFORM_API_STATUS = {
    COMPLETED: 'completed',
    FAILED: 'failed',
    IN_PROGRESS: 'in_progress',
    RESTART: 'waiting_api_restart'
};

exports.SYSLOG_MSG_EVENT_IDS = {
    AUTH: 6010,
    SERVICE_ACCOUNTS: 6020,
    MFA: 6030,
    DAILY_INSIGHTS: 6040,
    DIFF_INSIGHTS: 6050,
    NEW_INCIDENT: 6060,
    INCIDENT_AUTH_LOGS: 6061,
    RISK_LEVEL: 6070,
    POLICY_MATCH: 6080,
    PRIVILEGED_ACCOUNTS: 6090,
    AUDIT: {
        ADMIN_CONSOLE_FAILED_LOGIN: 6100,
        ADMIN_CONSOLE_SUCCESSFUL_LOGIN: 6101,
        POLICY_ACTIVATED: 6102,
        POLICY_DEACTIVATED: 6103,
        POLICY_SAVED: 6104,
        POLICY_DELETED: 6105,
        CERTIFICATE_UPLOADED: 6106,
        DOMAIN_CERTIFICATE_UPLOADED: 6107,
        DC_CERTIFICATE_UPLOADED: 6108,
        COMPANY_LOGO_UPLOADED: 6109,
        INITIATED_NODES_POWERUP: 6110,
        INITIATED_SINGLE_NODE_POWERUP: 6111,
        INITIATED_SYSTEM_POWERUP: 6112,
        INITIATED_SINGLE_NODE_SHUTDOWN: 6113,
        INITIATED_SYSTEM_SHUTDOWN: 6114,
        INITIATED_ACTIVE_DIRECTORY_SYNC: 6115,
        UPDATE_SETTINGS: 6116,
        UPDATE_PROTECTED_USER: 6117,
        INCLUDE_USER: 6118,
        EXCLUDE_USER: 6119,
        DELETE_USER_TOKEN: 6120,
        MAX_TOKENS_FOR_USER: 6121,
        SETTINGS_DETAILED_CHANGES: 6122,
        INITIATED_NODES_RECOVER: 6123,
        INITIATED_NODE_RESTART: 6124,
        POLICY_IMPORTED: 6125,
        POLICY_PRIORITIES_CHANGED: 6126,
        NEW_POLICY: 6127,
        POLICY_DETAILED_CHANGES: 6128,
        ENROLLED_USER_DELETED: 6129,
        EMAIL_SET_TO_USER: 6130,
        CERTIFICATE_ABOUT_TO_EXPIRE: 6131,
        CERTIFICATE_EXPIRED: 6132,
        SA_POLICY_ENABLED: 6133,
        SA_POLICY_DISABLED: 6134,
        SA_POLICY_CHANGED: 6135
    }
};

exports.SYSLOG_PROTOCOLS = {
    TCP: { value: 'tcp', label: 'TCP' },
    UDP: { value: 'udp', label: 'UDP' }
};

exports.SPLUNK_SYSLOG_MSG_TYPES = {
    DAILY_AUTH_STATISTIC: { value: 101 },
    INSIGHTS: { value: 102 },
    ENTITY_RISK_LEVELS: { value: 103 },
    TOP_RISK_USER: { value: 104 },
    TOP_RISK_RESOURCE: { value: 105 },
    SERVICE_ACCOUNTS_INSIGHTS: { value: 106 },
    SERVICE_ACCOUNT: { value: 107 }
};
exports.RISK_TO_NAME = ['Low', 'Medium', 'High', 'Critical', ''];

exports.ENTITY_STATISTIC_FILTER_TYPES = {
    RISK: 1,
    TIME: 2,
    TYPE: 3,
    LOCATION_EXISTS: 4
};

exports.LOGS_QUERY_TYPES = {
    TEXTUAL: 1,
    ACTION: 2,
    MFA_RESPONSE: 3,
    PROTOCOL: 4,
    RESULT: 5,
    RISK: 6,
    USER_TYPE: 7
};

exports.PROGRESS_BAR_STYLES = {
    background: '#E9F5FF'
};

exports.RISK_INDICATORS_FILTER_ID = 'riskIndicator';
exports.AUTHENTICATOR_FILTER_ID = 'authenticator';

exports.ES_LOGS_FILTERS = {
    idp: {
        key: 'vendor_id',
        type: 'terms'
    },
    accountDomain: {
        key: 'user_domain',
        type: 'regexp'
    },
    action: {
        key: 'effective_rule_action',
        type: 'terms'
    },
    deviceName: {
        key: 'host_name',
        type: 'regexp',
        filterGroup: 'source'
    },
    device: {
        key: ['host_guid'],
        type: 'terms',
        keyword: true,
        filterGroup: 'source'
    },
    domainController: {
        key: 'domain_controller',
        type: 'regexp'
    },
    ip: {
        key: 'ip_address',
        type: 'terms',
        filterGroup: 'source'
    },
    mfa: {
        key: 'user_response',
        type: 'terms',
        keyword: true
    },
    node: {
        key: 'wall_id',
        type: 'terms'
    },
    protocol: {
        key: 'protocol_type',
        type: 'terms',
        keyword: true
    },
    range: {
        key: 'timestamp',
        type: 'range'
    },
    resourceDomain: {
        key: 'server_domain',
        type: 'regexp'
    },
    result: {
        key: 'action',
        type: 'terms'
    },
    risk: {
        key: 'risk_level',
        type: 'terms'
    },
    [this.RISK_INDICATORS_FILTER_ID]: {
        key: 'risk_indicators_v2',
        type: 'terms'
    },
    ruleName: {
        key: 'effective_rule_id',
        type: 'terms'
    },
    serverName: {
        key: 'server',
        type: 'regexp'
    },
    serverIp: {
        key: 'server_ip',
        type: 'terms',
        filterGroup: 'destination'
    },
    server: {
        key: ['server_guid'],
        type: 'terms',
        keyword: true,
        filterGroup: 'destination'
    },
    service: {
        key: 'service',
        type: 'regexp'
    },
    username: {
        key: 'user_identifier',
        type: 'wildcard',
        keyword: true,
        filterGroup: 'user'
    },
    users: {
        key: 'user_guid',
        type: 'terms',
        keyword: true,
        filterGroup: 'user'
    },
    externalUsers: {
        key: 'external_user_id',
        type: 'terms',
        keyword: true,
        filterGroup: 'user'
    },
    userType: {
        key: 'user_type',
        type: 'terms'
    },
    alert: {
        key: 'alert',
        type: 'terms'
    },
    internalAuth: {
        key: 'is_internal_auth',
        type: 'terms'
    },
    deviceOrServer: {
        key: ['deviceName', 'serverName', 'ip', 'serverIp'],
        type: 'or'
    },
    includeSourceIpOrName: {
        key: ['deviceName', 'ip'],
        type: 'or',
        filterGroup: 'source'
    },
    excludeSourceIpOrName: {
        key: ['deviceName', 'ip'],
        type: 'or'
    },
    includeDestinationsIpOrName: {
        key: ['serverName', 'serverIp'],
        type: 'or',
        filterGroup: 'destination'
    },
    excludeDestinationsIpOrName: {
        key: ['serverName', 'serverIp'],
        type: 'or'
    },
    tokenId: {
        key: 'token_id',
        type: 'regexp'
    },
    authenticator: {
        key: 'authenticator',
        type: 'terms'
    },
    directoryType: {
        key: 'directory_type',
        type: 'terms'
    },
    retrospectiveAnswer: {
        key: 'retrospective_answer',
        type: 'terms'
    },
    reason: {
        key: 'reason',
        type: 'terms'
    },
    ruleNameExists: {
        key: 'effective_rule_id',
        type: 'exists'
    },
    country: {
        key: 'geo_device_country',
        type: 'terms',
        keyword: true
    },
    hideNoLocation: {
        key: 'geo_device_country',
        type: 'exists'
    },
    location: {
        key: 'geo_device_longitude',
        type: 'exists'
    },
    authMode: {
        key: 'auth_mode',
        type: 'terms'
    },
    originalTgt: {
        key: 'original_tgt',
        type: 'terms',
        keyword: true
    },
    requestID: {
        key: 'request_id',
        type: 'terms',
        keyword: true
    },
    smartPolicies: {
        key: 'group_policy_id',
        type: 'exists'
    },
    encryptionType: {
        key: ['encryptionTypeReply', 'encryptionTypeTicket'],
        type: 'or'
    },
    encryptionTypeReply: {
        key: 'krb_params.response_enc_type',
        type: 'terms'
    },
    encryptionTypeTicket: {
        key: 'krb_params.response_ticket_enc_type',
        type: 'terms'
    }
};

exports.ES_LOGS_GROUP_BY = {
    user: {
        key: 'user',
        esKey: 'user_guid',
        metaDataFields: ['sam', 'upn', 'user_identifier_display_name', 'user_identifier']
    },
    source: {
        key: 'source',
        esKey: 'host_guid',
        metaDataFields: ['host_name'],
        esFallBackKey: 'ip_address'
    },
    ip_address: {
        key: 'source',
        esKey: 'ip_address',
        metaDataFields: ['ip_address']
    },
    destination: {
        key: 'destination',
        esKey: 'server',
        esFallBackKey: 'server_ip',
        metaDataFields: ['server', 'server_ip', 'protocol_type', 'directory_type']
    },
    server_ip: {
        key: 'destination',
        esKey: 'server_ip',
        metaDataFields: ['server', 'server_ip', 'protocol_type', 'directory_type']
    }
};

exports.ES_LOGS_GROUP_BY_UI_OPTIONS = [
    {
        label: this.ES_LOGS_GROUP_BY.user.key,
        value: this.ES_LOGS_GROUP_BY.user.key
    },
    {
        label: this.ES_LOGS_GROUP_BY.source.key,
        value: this.ES_LOGS_GROUP_BY.source.key
    },
    {
        label: this.ES_LOGS_GROUP_BY.destination.key,
        value: this.ES_LOGS_GROUP_BY.destination.key
    }
];

exports.ES_EVENT_FILTERS = {
    range: {
        key: 'timestamp',
        type: 'range'
    },
    level: {
        key: 'level',
        type: 'terms'
    },
    eventSource: {
        key: 'event_source',
        type: 'terms'
    },
    domainController: {
        key: 'domain_controller',
        type: 'regexp'
    },
    code: {
        key: 'code',
        type: 'terms'
    },
    description: {
        key: 'description',
        type: 'regexp'
    }
};

exports.OsUpgradeHints = [
    {
        content:
            "Our OS migration wizard guides you through each stage of the migration process, ensuring a smooth transition. By migrating, you'll shield your system from vulnerabilities, keeping your personal information and activities safe.",
        title: 'Update your operating system effortlessly'
    },
    {
        content:
            'Before we begin, ensure a safety net. Take a snapshot of your Admin Console configuration. This snapshot will safeguard your progress and allow you to restore settings if needed',
        title: 'Secure Your Progress'
    },
    {
        content:
            'We understand the importance of time. Complete the migration process at your convenience. Save progress and pick up where you left off',
        title: 'Your schedule, your migration',
        actionText: 'Start Now'
    }
];

exports.LAYOUT_TABS = {
    DASHBOARD: { ID: 1, NAME: 'Dashboard', PRODUCT_NAME: 'dashboard' },
    INSIGHTS: { ID: 2, NAME: 'Insights', PRODUCT_NAME: 'insights' },
    POLICY: { ID: 3, NAME: 'Policy', PRODUCT_NAME: 'policies' },
    INVESTIGATION: { ID: 4, NAME: 'Investigation', PRODUCT_NAME: 'investigation' },
    MFA_USERS: { ID: 5, NAME: 'UserEnrollment', PRODUCT_NAME: 'user_enrollment' },
    LOGS: { ID: 6, NAME: 'Logs', PRODUCT_NAME: 'logs' },
    SYSTEM_SETUP: { ID: 7, NAME: 'Settings', PRODUCT_NAME: 'settings' },
    SYSTEM_STATUS: { ID: 8, NAME: 'SystemStatus', PRODUCT_NAME: 'system_status' },
    NODES_STATUS: { ID: 9, NAME: 'NodeStatus' },
    DCS_STATUS: { ID: 10, NAME: 'DCsStatus' },
    NOTIFICATIONS: { ID: 11, NAME: 'System Events', PRODUCT_NAME: 'notifications' },
    SOFTWARE_UPDATES: { ID: 12, NAME: 'SoftwareUpdates', PRODUCT_NAME: 'software_updates' },
    SERVICE_ACCOUNTS: { ID: 13, NAME: 'ServiceAccounts', PRODUCT_NAME: 'service_accounts' },
    APPLICATIONS_DISCOVERY: { ID: 14, NAME: 'ApplicationsDiscovery', PRODUCT_NAME: 'app_discovery' },
    ITDR: { ID: 15, NAME: 'Risk', PRODUCT_NAME: 'threat_detection' },
    ACCESS_ANALYSIS: { ID: 16, NAME: 'Access Intelligence', PRODUCT_NAME: 'access_analysis' },
    PRIVILEGED_ACCOUNTS: { ID: 17, NAME: 'PrivilegedAccounts', PRODUCT_NAME: 'pas' },
    INVENTORY: { ID: 18, NAME: 'Inventory', PRODUCT_NAME: 'inventory' },
    SERVICE_ACCOUNTS_CLOUD: { ID: 21, NAME: 'ServiceAccountsCloud', PRODUCT_NAME: 'service_accounts_cloud' },
    INSIGHTS_CLOUD: { ID: 23, NAME: 'InsightsCloud', PRODUCT_NAME: 'insights_cloud' },
    ITDR_CLOUD: { ID: 25, NAME: 'RiskCloud', PRODUCT_NAME: 'threat_detection_cloud' },
    ACCESS_ANALYSIS_CLOUD: { ID: 26, NAME: 'Access Intelligence Cloud', PRODUCT_NAME: 'access_analysis_cloud' },
    AI_AGENT_SECURITY_CLOUD: { ID: 27, NAME: 'AI Agent Security', PRODUCT_NAME: 'ai_agent_security_cloud' },
    USER_MANAGEMENT: { ID: 28, NAME: 'UserManagement', PRODUCT_NAME: 'user_management' },
    INCIDENT_INVESTIGATION: { ID: 29, NAME: 'Investigation', PRODUCT_NAME: 'investigation' },
    AUTHENTICATION_FIREWALL_DASHBOARD: {
        ID: 30,
        NAME: 'AuthenticationFirewall',
        PRODUCT_NAME: 'authentication_firewall'
    },
    UNIVERSAL_MFA_DASHBOARD: {
        ID: 31,
        NAME: 'UniversalMFA',
        PRODUCT_NAME: 'universal_mfa'
    },
    AI_AGENT_PROTECTION_CLOUD: { ID: 32, NAME: 'AI Agent Protection', PRODUCT_NAME: 'ai_agent_protection_cloud' },
    AI_ASSISTANT: { ID: 33, NAME: 'AI Assistant', PRODUCT_NAME: 'ai_assistant' }
};

exports.TOWER_MENU_ITEMS = {
    DASHBOARD: this.LAYOUT_TABS.DASHBOARD.ID.toString(),
    INVENTORY: this.LAYOUT_TABS.INVENTORY.ID.toString(),
    PROTECTION_POLICIES: this.LAYOUT_TABS.POLICY.ID.toString(),
    PROTECTION_USER_ENROLLMENT: this.LAYOUT_TABS.MFA_USERS.ID.toString(),
    PROTECTION_USER_MANAGEMENT: this.LAYOUT_TABS.USER_MANAGEMENT.ID.toString(),
    PA: this.LAYOUT_TABS.PRIVILEGED_ACCOUNTS.ID.toString(),
    NHI: 'Menu-NHI',
    NHI_AD: this.LAYOUT_TABS.SERVICE_ACCOUNTS.ID.toString(),
    NHI_CLOUD: this.LAYOUT_TABS.SERVICE_ACCOUNTS_CLOUD.ID.toString(),
    ISPM: 'Menu-ISPM',
    ISPM_AD: this.LAYOUT_TABS.INSIGHTS.ID.toString(),
    ISPM_CLOUD: this.LAYOUT_TABS.INSIGHTS_CLOUD.ID.toString(),
    ITDR: 'Menu-ITDR',
    ITDR_AD: this.LAYOUT_TABS.ITDR.ID.toString(),
    ITDR_CLOUD: this.LAYOUT_TABS.ITDR_CLOUD.ID.toString(),
    ACCESS_ANALYSIS: 'Menu-Access-Analysis',
    ACCESS_ANALYSIS_AD: this.LAYOUT_TABS.ACCESS_ANALYSIS.ID.toString(),
    ACCESS_ANALYSIS_CLOUD: this.LAYOUT_TABS.ACCESS_ANALYSIS_CLOUD.ID.toString(),
    APP_DISCOVERY: this.LAYOUT_TABS.APPLICATIONS_DISCOVERY.ID.toString(),
    LOGS: this.LAYOUT_TABS.LOGS.ID.toString(),
    MONITOR: 'Menu-Monitor',
    MONITOR_SYSTEM_STATUS: this.LAYOUT_TABS.SYSTEM_STATUS.ID.toString(),
    MONITOR_NOTIFICATIONS: this.LAYOUT_TABS.NOTIFICATIONS.ID.toString(),
    MONITOR_SOFTWARE_UPDATES: this.LAYOUT_TABS.SOFTWARE_UPDATES.ID.toString(),
    SETTINGS: this.LAYOUT_TABS.SYSTEM_SETUP.ID.toString(),
    LOGOUT: 'Menu-Logout',
    AI_SECURITY: 'Menu-AI-Security',
    AI_AGENT_SECURITY_CLOUD: this.LAYOUT_TABS.AI_AGENT_SECURITY_CLOUD.ID.toString(),
    INCIDENT_INVESTIGATION: 'investigation',
    AUTHENTICATION_FIREWALL: 'Menu-Authentication-Firewall',
    AUTHENTICATION_FIREWALL_DASHBOARD: this.LAYOUT_TABS.AUTHENTICATION_FIREWALL_DASHBOARD.ID.toString(),
    UNIVERSAL_MFA: 'Menu-Universal-MFA',
    UNIVERSAL_MFA_DASHBOARD: this.LAYOUT_TABS.UNIVERSAL_MFA_DASHBOARD.ID.toString(),
    AI_AGENT_PROTECTION_CLOUD: this.LAYOUT_TABS.AI_AGENT_PROTECTION_CLOUD.ID.toString(),
    AI_ASSISTANT: this.LAYOUT_TABS.AI_ASSISTANT.ID.toString()
};

exports.BASELINE_CHANGE = [15, 30, 60, 90, 120, 180];

exports.INFINITE_SCROLL_BATCH_SIZE = 100;

exports.NO_HITS_IN_LOGS_AGGS = 0;

exports.SINGLE_HIT_ONLY_SIZE = 1;

exports.DB_DEFAULT_CHUNK_SIZE = 1000;

exports.NOTIFICATION_TYPES = {
    NODE_STATE_CHANGE: 1,
    DC_STATE_CHANGE: 2,
    SYSTEM_STATE_CHANGE: 3
};

exports.AUTHENTICATOR_TYPES = {
    CHROME: {
        value: 'chrome',
        label: 'Silverfort Chrome'
    },
    DUO: {
        value: 'duo',
        label: 'Duo Mobile'
    },
    MICROSOFT: {
        value: 'microsoft',
        label: 'MS Authenticator'
    },
    MOBILE: {
        value: 'mobile',
        label: 'Silverfort Mobile'
    },
    OKTA: {
        value: 'okta',
        label: 'Okta Verify'
    },
    PING: {
        value: 'ping',
        label: 'PingID'
    },
    RSA: {
        value: 'rsa',
        label: 'RSA SecurID'
    },
    DESKTOP: {
        value: 'desktop',
        label: 'Silverfort Desktop'
    },
    OTP: {
        value: 'otp',
        label: 'OTP'
    },
    WEBAUTHN: {
        value: 'webauthn',
        label: 'FIDO2'
    },

    HYPR: {
        value: 'hypr',
        label: 'HYPR'
    },
    EXTERNAL_PUSH: {
        value: 'external_push',
        label: 'External - Push'
    },
    EXTERNAL_OTP: {
        value: 'external_otp',
        label: 'External - OTP'
    },
    RADIUS_OTP: {
        value: 'radius_otp',
        label: 'RADIUS OTP'
    },
    BRIDGE_SSO: {
        value: 'sso',
        label: 'Identity Bridge'
    }
};

exports.LOG_SOURCE = {
    INTERNAL: 1,
    EXTERNAL: 2
};

exports.EXTERNAL_NOTIFICATIONS_SOURCE = {
    CHECKPOINT: 1,
    PALO_ALTO: 2
};

exports.LOGS_PAGE_URL_PREFIX = '/Logs';

exports.MFA_DEVICE_TYPES = {
    ANDROID: {
        TYPE: 0,
        NAME: 'Android',
        RAVEN_KEY: 'android'
    },
    IOS: {
        TYPE: 1,
        NAME: 'iOS',
        RAVEN_KEY: 'ios'
    },
    CHROME: {
        TYPE: 2,
        NAME: 'Chrome',
        RAVEN_KEY: 'chrome'
    },
    WEBAUTHN: {
        TYPE: 3,
        NAME: 'WebAuthn',
        RAVEN_KEY: 'webauthn'
    },
    APP: {
        TYPE: 4,
        NAME: 'App',
        RAVEN_KEY: 'client_app'
    },
    OTP: {
        TYPE: 5,
        NAME: 'Authenticator',
        RAVEN_KEY: 'otp'
    },
    // Type 6 is taken on the Wall side by Credential Provider
    MS_TEAMS: {
        TYPE: 7,
        NAME: 'Microsoft Teams',
        RAVEN_KEY: 'ms_teams'
    }
};

exports.OTP_UPLOAD_STATUS_KEYS = {
    VALID_USER: 'validUser',
    INSERTED: 'inserted'
};

exports.OTP_UPLOAD_INVALID_TOKEN = 'invalidToken';

exports.NODE_MODES = {
    ACTIVE: 'active',
    PASSIVE: 'passive'
};

exports.SYSTEM_STATUS_INTERVAL = 15000;
exports.TOWER_ID = 'tower';
exports.PLATFORM_ID = 'platform';
exports.DUMPER_ID = 'dumper';

exports.GENERATE_CERTIFICATE_TYPES = {
    AAD: 1
};

exports.MOBILE_MESSAGING_SERVICE = 'Mobile-Messaging-Service';
exports.DESKTOP_MESSAGING_SERVICE = 'Desktop-Messaging-Service';

exports.EXTERNAL_API_USER = 'api-user';

exports.DIFF_OBJECTS_TYPES = { POLICY: 'Policy', SETTINGS: 'Settings' };

exports.POLICY_MATCHING_BY_OPTIONS = {
    CLIENT: {
        value: 'client_host',
        label: 'Source'
    },
    SERVER: {
        value: 'server_id',
        label: 'Destination'
    },
    TGT: {
        value: 'original_tgt',
        label: 'Specific TGT'
    },
    RISK: {
        value: 'risk',
        label: 'Risk Level'
    },
    IP: {
        value: 'src_ip',
        label: 'Source IP'
    }
};

exports.POLICY_MATCHING_BY_OPTIONS_SOURCE_HOSTNAME_LABEL = 'Source Hostname';

exports.FIELDS_TO_LABELS_MAPPER = {
    CompanyName: 'Company Name',
    CompanyLogo: 'Company Logo',
    CompanySupportEmail: 'Organization Support Email',
    UserTokensLimit: 'Maximum User Tokens',
    AADApplicationsRedirectURI: 'Entra ID Applications Redirect URI',
    OktaRedirectURI: 'Okta Applications Redirect URI',
    SMTPServerURL: 'SMTP Server',
    SMTPFrom: 'SMTP From Address',
    SMTPUsername: 'SMTP Account',
    OktaUPNField: 'Okta User Identifier Field',
    OktaUrl: 'Okta URL',
    OktaAPIToken: 'Okta API Token',
    RSAUPNField: 'RSA User Identifier Field',
    RSARestEndpoint: 'RSA REST Endpoint',
    RSAApiKey: 'RSA API Key',
    DuoUPNField: 'Duo User Identifier Field',
    DuoAPIHostname: 'Duo API Hostname',
    DuoIntegrationKey: 'Duo Integration Key',
    DuoSecretKey: 'Duo Secret Key',
    HyprAppId: 'HYPR App ID',
    HyprAccessToken: 'HYPR Access Token',
    AADPublicKey: 'AAD Public Key',
    AADUPNField: 'Azure User Identifier Field',
    PingUPNField: 'Ping User Identifier Field',
    PingAPIKey: 'Ping Base64 API key',
    PingToken: 'Ping Token',
    PingOrgAlias: 'Ping Organisation Alias',
    PingURL: 'Ping IdP URL',
    ConsoleUsername: 'Admin Console',
    APIUsername: 'Silverfort MFA API User',
    SNMPUsername: 'SNMP',
    HTTPProxy: 'HTTP Proxy',
    HTTPSProxy: 'HTTPS Proxy',
    LogLevel: 'Nodes Log Level',
    PushServicesEnabled: 'Desktop Messaging Services',
    OverwriteAryaLogo: 'Display Company Logo on Silverfort Desktop App',
    PushServicesExternalIntegrationEnabled: 'Custom MFA integration',
    PushServicesExternalIntegrationApiKey: 'Custom MFA integration key',
    FailsafeMechanism: 'Fail-Open',
    ADFSAPIToken: 'ADFS API Token',
    AppUserId: 'Application User ID',
    NotificationEmail: 'Notifications Email',
    AutoDenyMfaThreshold: 'Number of denied MFA request',
    AutoDenyMfaWindowSize: 'Max Block Time',
    SSOEnabled: 'Single Sign On',
    SSOProtocol: 'SSO Protocol',
    SSOCallbackUrl: 'SSO Callback URL',
    SSOLoginUrl: 'SSO Login URL',
    SSOIdpIssuer: 'SSO IdP Issuer',
    SSOButtonText: 'SSO Button Text',
    SSODisableRequestedAuthnContext: 'SSO Disable Requested Authn',
    SSOAuthnContext: 'SSO Authn Context',
    OfflineMode: 'Offline Mode',
    NotificationHeight: 'Window Height (pixels)',
    NotificationWidth: 'Window Width (pixels)',
    NotificationInCenterPosition: 'Window Position',
    CustomNotificationTitle: 'Notification Title',
    CustomMFANotification: 'MFA Notification Text',
    CustomTimeoutNotification: 'Timeout Notification Text',
    userMessageTimeout: 'Notifications Timeout',
    hideUserMessageTimeout: 'Show countdown',
    NotificationIcon: 'Notification Icon',
    ShowNotificationIcon: 'Display notification icon',
    NotificationBackground: 'Notification Background',
    SimpleTrayOpen: 'User Enrollment window',
    PushServicesSecondaryUrl: 'Secondary URL',
    DesktopMFAClientSecret: 'Silverfort for Windows Logon Token',
    ShowOtpOnAutoPairedDevice: 'Show OTP On Auto Paired Devices',
    OtpNotificationIcon: 'OTP Icon',
    OtpNotificationBackground1: 'OTP Background (step 1)',
    OtpNotificationBackground2: 'OTP Background (step 2)',
    ShowOtpNotificationIcon: 'Display notification icon',
    OtpNotificationHeight: 'OTP Window Height (pixels)',
    OtpNotificationWidth: 'OTP Window Width (pixels)',
    CustomOtpNotification: 'OTP Notification Text',
    OtpNotificationInCenterPosition: 'OTP Window Position',
    DumperSendDailyAutomatically: 'Send Diagnostics to Silverfort',
    DumperSendAutoAnonymized: 'Anonymized',
    SaasSupportEnabled: 'Enable Silverfort Support'
};

exports.DATA_STREAMER_DATA_TYPES = {
    JIT_ACTION_EVENTS: 'JitActionEvents',
    LDAP_QUERIES: 'LdapQueries',
    DC_SYNC_EVENTS: 'DcSyncEvents',
    PAS_POLICY_JIT_CHANGE: 'PasPolicyJit',
    PAS_POLICY_FENCING_CHANGE: 'PasPolicyFencing',
    EVENT_LOGS: 'EventLogs'
};

exports.PRODUCT_DATA_CREATION_FLOW_TYPES = {
    MANUAL: 'manual',
    API: 'api',
    BULK: 'bulk'
};

exports.PRODUCT_DATA_ACTION_TYPES = {
    CREATE: 'create',
    UPDATE: 'update',
    BACKFILL: 'backfill'
};

exports.FIELDS_TO_HIDE = {
    ADFSAPIToken: true,
    RADIUSClients: ['encKey'],
    DuoIntegrationKey: true,
    DuoSecretKey: true,
    RSAApiKey: true,
    OktaAPIToken: true,
    PingAPIKey: true,
    PingToken: true,
    HyprAccessToken: true,
    customMfaIntegrationKey: true,
    clientSecret: true,
    AdminConsoleApiKey: true,
    DesktopMFAClientSecret: true
};

exports.MFA_WINDOW_TYPES = {
    MINUTES: { label: 'Minutes', value: 1 },
    HOURS: { label: 'Hours', value: 60 },
    DAYS: { label: 'Days', value: 60 * 24 }
};

exports.UNPAIRED_USERS_ACTION_OPTIONS = {
    DEFAULT: { value: 0, label: 'Default' },
    ALLOW_ACCESS: { value: 1, label: 'Allow Access' },
    BLOCK_ACCESS: { value: 2, label: 'Block access' }
};

exports.TIME_RESTRICTION_TYPE_OPTIONS = {
    ALWAYS: { value: 1, label: 'Always' },
    WHITE_LIST_TIMES: { value: 2, label: 'At the following times' },
    BLACK_LIST_TIMES: { value: 3, label: 'Except the following times' }
};

exports.LOCATION_TYPE_OPTIONS = {
    EVERYWHERE: { value: 1, label: 'Everywhere' },
    INCLUDE_LOCATIONS: { value: 2, label: 'At the following countries' },
    EXCLUDE_LOCATIONS: { value: 3, label: 'Except the following countries' }
};

exports.LOCATION_ENABLED_PROTOCOLS = ['oidc_enabled', 'desktop_enabled', 'okta_enabled'];

exports.RELYING_PARTY_SERVER_NAME = 'adfs';

exports.SERVICE_ACCOUNTS_EXPORTS_SORT = {
    ORDER_BY: 'name', // When Change please check if export queries support the column.
    ORDER_DIRECTION: 'ASC'
};

exports.SERVICE_ACCOUNTS_ENTITY_TYPES = {
    RESOURCE: 'resource',
    DEVICE: 'device'
};

exports.SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES = {
    GUID: 'guid',
    NAME: 'name',
    IP: 'ip'
};

exports.SERVICE_ACCOUNTS_ENTITY_HIT_LASTUSE_TYPES = {
    RESOURCE_IPS: 'resource_ips',
    RESOURCES: 'resources',
    DEVICE_IPS: 'device_ips',
    DEVICES: 'devices'
};

exports.MAP_SA_ENTITY_HIT_LASTUSE_TYPES_TO_ENTITY_PKS = {
    [this.SERVICE_ACCOUNTS_ENTITY_HIT_LASTUSE_TYPES.DEVICES]: {
        entityType: this.SERVICE_ACCOUNTS_ENTITY_TYPES.DEVICE,
        identifierType: this.SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.NAME
    },
    [this.SERVICE_ACCOUNTS_ENTITY_HIT_LASTUSE_TYPES.DEVICE_IPS]: {
        entityType: this.SERVICE_ACCOUNTS_ENTITY_TYPES.DEVICE,
        identifierType: this.SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.IP
    },
    [this.SERVICE_ACCOUNTS_ENTITY_HIT_LASTUSE_TYPES.RESOURCES]: {
        entityType: this.SERVICE_ACCOUNTS_ENTITY_TYPES.RESOURCE,
        identifierType: this.SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.GUID
    },
    [this.SERVICE_ACCOUNTS_ENTITY_HIT_LASTUSE_TYPES.RESOURCE_IPS]: {
        entityType: this.SERVICE_ACCOUNTS_ENTITY_TYPES.RESOURCE,
        identifierType: this.SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.IP
    }
};

exports.RULES_TYPES = {
    REGULAR: 'regular',
    SERVICE_ACCOUNTS: 'service_accounts',
    FENCING: 'fencing'
};

exports.RULE_TYPE_TO_PADDING = {
    [this.RULES_TYPES.REGULAR]: 0,
    [this.RULES_TYPES.SERVICE_ACCOUNTS]: this.SERVICE_ACCOUNTS_RULES_PADDING,
    [this.RULES_TYPES.FENCING]: this.FENCING_RULES_PADDING
};

exports.INVENTORY_ITEMS = {
    users: { title: 'Users', order: 1 },
    groups: { title: 'Security Groups', order: 2 },
    oktaapps: {
        title: 'Okta Applications',
        type: this.AD_ENTITY_TYPES.OKTA,
        order: 3
    },
    azureapps: {
        title: 'Entra ID Applications',
        type: this.AD_ENTITY_TYPES.APPLICATION,
        order: 4
    },
    servers: { title: 'Servers', order: 5 },
    domains: { title: 'Domains', order: 6 },
    ous: { title: 'Organizational Units', order: 7 }
};

exports.PREDICTABILITY_LEVELS = {
    NO_SERVICE_ACCOUNT: { id: 0, display: 'none' },
    LOW: { id: 1, display: 'Low' },
    MEDIUM: { id: 2, display: 'Medium' },
    HIGH: { id: 3, display: 'High' }
};
exports.DEFAULT_POLICY_ID = -1;

exports.DEFAULT_MFA_PROMPT = '$username, are you trying to access $destination from $source?';
exports.DEFAULT_MFA_PROMPT_KERBEROS = '$username, are you trying to access $destination/$spn from $source?';
exports.DEFAULT_MFA_PROMPT_NO_SOURCE = '$username, are you trying to access $destination?';

exports.POC_USE_CASES = {
    VISIBILITY: {
        value: 1,
        label: 'Visibility & Auditing'
    },
    IAM: {
        value: 2,
        label: 'IAM hygiene & security assessment (static insights)'
    },
    REAL_TIME: {
        value: 3,
        label: 'Threat hunting and identity forensics (real time investigation)'
    },
    VPN: {
        value: 4,
        label: 'MFA for VPN'
    },
    PREMISE: {
        value: 5,
        label: 'MFA for on-prem assets'
    },
    CLOUD: {
        value: 6,
        label: 'MFA for cloud assets'
    },
    RISK: {
        value: 7,
        label: 'Risk based authentication'
    },
    LATERAL: {
        value: 8,
        label: 'Lateral movement prevention'
    },
    ZERO_TRUST: {
        value: 9,
        label: 'Conditional access & zero trust'
    },
    SERVICE_ACCOUNT: {
        value: 10,
        label: 'Service account discovery & monitoring'
    },
    SERVICE_ACCOUNT_PROTECTION: {
        value: 11,
        label: 'Service account protection'
    },
    CROSS_IDP: {
        value: 12,
        label: 'Cross IdP application discovery'
    },
    LEGACY_ASSETS: {
        value: 13,
        label: 'Connecting legacy assets to cloud IdP'
    }
};

exports.ACTIVE_DIRECTORY_PROTECT = { value: 1, label: 'Active Directory' };
exports.ENABLED_PROTOCOLS_TO_PROTECT = {
    ntlm_enabled: this.ACTIVE_DIRECTORY_PROTECT,
    kerberos_enabled: this.ACTIVE_DIRECTORY_PROTECT,
    ldap_enabled: this.ACTIVE_DIRECTORY_PROTECT,
    oidc_enabled: { value: 2, label: 'Entra ID' },
    radius_enabled: { value: 3, label: 'RADIUS' },
    relying_parties_enabled: { value: 4, label: 'ADFS' },
    desktop_enabled: { value: 5, label: 'Windows Logon' },
    ping_fed_enabled: { value: 6, label: 'PingFederate' },
    okta_enabled: { value: 7, label: 'Okta' }
};

exports.ENTITY_SELECTOR_FILTER_TYPES = {
    ALL: { value: 1, buttonText: 'All' },
    USERS_ONLY: { value: 2, buttonText: 'Users', searchEntitiesTypes: [this.AD_ENTITY_TYPES.USER] },
    GROUPS_ONLY: { value: 3, buttonText: 'Groups', searchEntitiesTypes: [this.AD_ENTITY_TYPES.GROUP] },
    OUS_ONLY: { value: 4, buttonText: 'OUs', searchEntitiesTypes: [this.AD_ENTITY_TYPES.OU] },
    HOSTS_ONLY: { value: 5, buttonText: 'Hosts', searchEntitiesTypes: [this.AD_ENTITY_TYPES.HOST] },
    SERVERS_ONLY: { value: 6, buttonText: 'Servers', searchEntitiesTypes: [this.AD_ENTITY_TYPES.SERVER] },
    LOCALS_ONLY: { value: 7, buttonText: 'Local', searchEntitiesTypes: [this.AD_ENTITY_TYPES.LOCAL_ACCOUNT] }
};

exports.ACCOUNT_TYPE_TO_DISPLAY = {
    DISPLAY_NAME: { value: 1, label: 'Display name' },
    FULL_PATH: { value: 2, label: 'Full Path' },
    SAM_ACCOUNT: { value: 3, label: 'Sam account name' },
    DEVICE_NAME: { value: 4, label: 'Device name' }
};

exports.SELECTOR_TYPES = {
    ENROLLED_GROUPS: {
        value: 1,
        hasExcludes: false,
        modalTitle: 'Manage Protected Groups',
        placeholderText: 'Search groups or organizational units name',
        filters: [
            this.ENTITY_SELECTOR_FILTER_TYPES.ALL,
            this.ENTITY_SELECTOR_FILTER_TYPES.GROUPS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.OUS_ONLY
        ],
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.GROUP, this.AD_ENTITY_TYPES.OU]
    },
    ENTITIES: {
        value: 2,
        hasExcludes: true,
        modalTitle: 'Select Entities',
        placeholderText: 'Search users, groups or organizational units',
        filters: [
            this.ENTITY_SELECTOR_FILTER_TYPES.ALL,
            this.ENTITY_SELECTOR_FILTER_TYPES.USERS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.GROUPS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.OUS_ONLY
        ],
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.USER, this.AD_ENTITY_TYPES.GROUP, this.AD_ENTITY_TYPES.OU]
    },
    DEVICES: {
        value: 3,
        hasExcludes: true,
        managedSelectorTitle: 'Devices',
        unmanagedSelectorTitle: 'Unmanaged Devices',
        modalTitle: 'Select Devices',
        placeholderText: 'Search devices',
        filters: [
            this.ENTITY_SELECTOR_FILTER_TYPES.ALL,
            this.ENTITY_SELECTOR_FILTER_TYPES.HOSTS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.GROUPS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.OUS_ONLY
        ],
        entityType: this.AD_ENTITY_TYPES.HOST,
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.OU, this.AD_ENTITY_TYPES.GROUP, this.AD_ENTITY_TYPES.HOST]
    },
    USERS: {
        value: 4,
        hasExcludes: true,
        managedSelectorTitle: 'Users',
        unmanagedSelectorTitle: 'Usernames',
        modalTitle: 'Select Users',
        placeholderText: 'Search users',
        filters: [],
        entityType: this.AD_ENTITY_TYPES.USER,
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.USER, this.AD_ENTITY_TYPES.LOCAL_ACCOUNT]
    },
    SERVERS: {
        value: 5,
        hasExcludes: false,
        managedSelectorTitle: 'Resources',
        unmanagedSelectorTitle: 'Unmanaged Resources',
        modalTitle: 'Select Resources',
        placeholderText: 'Search servers, groups or organizational units',
        filters: [
            this.ENTITY_SELECTOR_FILTER_TYPES.ALL,
            this.ENTITY_SELECTOR_FILTER_TYPES.SERVERS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.GROUPS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.OUS_ONLY
        ],
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.GROUP, this.AD_ENTITY_TYPES.OU, this.AD_ENTITY_TYPES.SERVER]
    },
    DEVICES_ONLY: {
        value: 6,
        hasExcludes: true,
        managedSelectorTitle: 'Devices',
        unmanagedSelectorTitle: 'Unmanaged Devices',
        modalTitle: 'Select Devices',
        placeholderText: 'Search devices',
        filters: [this.ENTITY_SELECTOR_FILTER_TYPES.HOSTS_ONLY],
        entityType: this.AD_ENTITY_TYPES.HOST,
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.HOST]
    },
    SERVERS_ONLY: {
        value: 7,
        hasExcludes: false,
        managedSelectorTitle: 'Resources',
        unmanagedSelectorTitle: 'Unmanaged Resources',
        modalTitle: 'Select Resources',
        placeholderText: 'Search servers',
        filters: [this.ENTITY_SELECTOR_FILTER_TYPES.SERVERS_ONLY],
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.SERVER]
    },
    APPLICATIONS: {
        value: 8,
        hasExcludes: true,
        managedSelectorTitle: 'Applications',
        modalTitle: 'Select Applications',
        placeholderText: 'Search applications',
        filters: [],
        searchEntitiesTypes: [this.AD_ENTITY_TYPES.APPLICATION]
    },
    AD_ENTITIES_AND_LOCAL_ACCOUNTS: {
        value: 9,
        hasExcludes: true,
        modalTitle: 'Select Entities',
        placeholderText: 'Search users, groups or organizational units',
        filters: [
            this.ENTITY_SELECTOR_FILTER_TYPES.ALL,
            this.ENTITY_SELECTOR_FILTER_TYPES.USERS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.GROUPS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.OUS_ONLY,
            this.ENTITY_SELECTOR_FILTER_TYPES.LOCALS_ONLY
        ],
        searchEntitiesTypes: [
            this.AD_ENTITY_TYPES.USER,
            this.AD_ENTITY_TYPES.GROUP,
            this.AD_ENTITY_TYPES.OU,
            this.AD_ENTITY_TYPES.LOCAL_ACCOUNT
        ]
    }
};

exports.POLICY_MODE_TYPES = {
    ONLINE: { value: 1, label: 'Online' },
    OFFLINE: { value: 2, label: 'Offline' },
    ONLINE_AND_OFFLINE: { value: 3, label: 'Online and Offline' }
};

exports.SYSTEM_STATUS_ACTIONS = {
    START: 'start',
    RECOVER: 'recover'
};

exports.POLICIES_HITS_TIME_UNITS_TYPES = {
    HOURS: { label: 'Hours', value: 'h' },
    DAYS: { label: 'Days', value: 'd' },
    WEEKS: { label: 'Weeks', value: 'w' }
};

exports.SORT_DIRECTION = {
    ASC: 1,
    DESC: -1
};

exports.COLUMN_TYPES = {
    INT: 1,
    STRING: 2,
    BOOLEAN: 3,
    CUSTOM: 4
};

exports.LOGS_DISPLAY_ACCOUNT_TYPES = {
    SHORT_UPN: { label: 'Short UPN', value: 1 },
    UPN: { label: 'UPN', value: 2 },
    SAM: { label: 'SAM Account', value: 3 }
};

exports.AUTH_TYPES_GRAPHS_COLORS = {
    ad: 'rgba(24, 141, 237, 1)',
    aad: 'rgba(49, 193, 120, 1)',
    adfs: 'rgba(132, 130, 130, 1)',
    pingfed: 'rgba(241, 32, 241, 1)',
    radius: 'rgba(241, 32, 71, 1)'
};

exports.RANGE_FILTER_TYPES = {
    LAST_HOUR: { label: 'Last hour', value: 1 },
    TODAY: { label: 'Today', value: 2 },
    YESTERDAY: { label: 'Yesterday', value: 3, subValueInDays: 1 },
    LAST_7_DAYS: { label: 'Last 7 days', value: 4, subValueInDays: 7 },
    LAST_14_DAYS: { label: 'Last 14 days', value: 5, subValueInDays: 14 },
    LAST_30_DAYS: { label: 'Last 30 days', value: 6, subValueInDays: 30 },
    CUSTOM_RANGE: { label: 'Custom range', value: 7 }
};

exports.RISK_RANGE_FILTER = {
    LAST_7_DAYS: { title: 'Last 7 days', value: 4, subValueInDays: 7 },
    LAST_14_DAYS: { title: 'Last 14 days', value: 5, subValueInDays: 14 },
    LAST_30_DAYS: { title: 'Last 30 days', value: 6, subValueInDays: 30 },
    LAST_90_DAYS: { title: 'Last 90 days', value: 8, subValueInDays: 90 },
    LAST_180_DAYS: { title: 'Last 180 days', value: 9, subValueInDays: 180 },
    LAST_YEAR: { title: 'Last year', value: 0, subValueInDays: 365 }
};

exports.AUTO_PROTECT_OPTIONIOS = {
    alert_after: 1,
    block_after: 2
};
exports.RANGE_AUTO_PROTECT = [
    { label: 'Immediately', value: 1, subValueInDays: 0 },
    { label: '7 days', value: 2, subValueInDays: 7 },
    { label: '15 days', value: 3, subValueInDays: 15 },
    { label: '30 days', value: 4, subValueInDays: 30 },
    { label: '45 days', value: 5, subValueInDays: 45 },
    { label: '60 days', value: 7, subValueInDays: 60 },
    { label: '90 days', value: 8, subValueInDays: 90 },
    { label: 'Never', value: 6 }
];

exports.BASELINE_CHANGE_OPTIONS = [
    { label: 'Last 15 days', value: 15 },
    { label: 'Last 30 days', value: 30 },
    { label: 'Last 60 days', value: 60 },
    { label: 'Last 90 days', value: 90 },
    { label: 'Last 120 days', value: 120 },
    { label: 'Last 180 days', value: 180 }
];

exports.DAYS_OPTIONS = {
    MONDAY: { label: 'Monday', value: 1, shortName: 'M' },
    TUESDAY: { label: 'Tuesday', value: 2, shortName: 'T' },
    WEDNESDAY: { label: 'Wednesday', value: 3, shortName: 'W' },
    THURSDAY: { label: 'Thursday', value: 4, shortName: 'T' },
    FRIDAY: { label: 'Friday', value: 5, shortName: 'F' },
    SATURDAY: { label: 'Saturday', value: 6, shortName: 'S' },
    SUNDAY: { label: 'Sunday', value: 7, shortName: 'S' }
};

// TODO: Remove on v5.3
exports.AZURE_SSO_AUTHENTICATION_VALUE = 'azure_sso';

exports.FREQUENCY_OPTIONS = {
    DAILY: { label: 'Daily', value: 1 },
    WEEKLY: { label: 'Weekly', value: 2 },
    MONTHLY: { label: 'Monthly', value: 3 }
};

exports.PERIOD_OPTIONS = {
    DAY: { label: 'Day', value: 1 },
    WEEK: { label: 'Week', value: 7 },
    MONTH: { label: 'Month', value: 30 }
};

exports.WEAK_ENCRYPTION_TYPES = {
    1: 'DES-CBC-CRC',
    2: 'DES-CBC-MD4',
    3: 'DES-CBC-MD5',
    4: 'DES-CBC-raw',
    6: 'DES3-CBC-raw',
    23: 'RC4-HMAC',
    24: 'RC4-HMAC-EXP'
};

exports.KERBEROS_ENCRYPTION_TYPES = {
    18: 'AES256-CTS-HMAC-SHA1-96',
    17: 'AES128-CTS-HMAC-SHA1-96',
    23: 'RC4-HMAC',
    24: 'RC4-HMAC-EXP',
    1:  'DES-CBC-CRC',
    3:  'DES-CBC-MD5',
    2:  'DES-CBC-MD4',
    4:  'DES-CBC-raw',
    6:  'DES3-CBC-raw'
};

exports.WEAK_CIPHER_TYPES = {
    26114: 'CALG_RC2',
    26115: 'CALG_3DES',
    26121: 'CALG_3DES_112',
    26625: 'CALG_RC4',
    26129: 'CALG_DES',
    32769: 'CALG_MD2',
    32770: 'CALG_MD4',
    32771: 'CALG_MD5',
    32772: 'CALG_SHA1'
};

exports.OBSOLETE_TLS_TYPES = {
    8: 'SP_PROT_SSL2_CLIENT',
    4: 'SP_PROT_SSL2_SERVER',
    32: 'SP_PROT_SSL3_CLIENT',
    16: 'SP_PROT_SSL3_SERVER',
    128: 'SP_PROT_TLS1_0_CLIENT',
    64: 'SP_PROT_TLS1_0_SERVER',
    512: 'SP_PROT_TLS1_1_CLIENT',
    256: 'SP_PROT_TLS1_1_SERVER',
    131072: 'SP_PROT_DTLS1_0_CLIENT',
    65536: 'SP_PROT_DTLS1_0_SERVER'
};

exports.RETROSPECTIVE_ANSWER = {
    yes: { key: 'true', displayName: 'Yes' },
    no: { key: 'false', displayName: 'No' },
    pending: { key: 'pending', displayName: 'Pending response' },
    expired: { key: 'expired', displayName: 'Request expired' }
};

exports.KRBTGT = 'krbtgt';

exports.INSIGHT_STATUSES = {
    ACTIVE: 'risky',
    HIDDEN: 'hidden',
    DISMISSED: 'disabled'
};

exports.INSIGHT_STATUS_DESCRIPTIONS = {
    OPEN: 'Open',
    IN_PROGRESS: 'In Progress',
    ACCEPTED: 'Accepted',
    RESOLVED: 'Resolved',
    FALSE_POSITIVE: 'False Positive',
    PROTECTED: 'Protected',
    MITIGATED: 'Mitigated'
};

exports.INSIGHTS_FEEDBACK_OPTIONS = {
    [this.INSIGHT_STATUSES.ACTIVE]: {
        status: this.INSIGHT_STATUSES.ACTIVE,
        filterLabel: 'No Feedback',
        label: 'No Feedback',
        description: 'Retain the risk indicator for the selected entities.',
        confirmationText:
            'If you approve this action, current feedback of the selected entities will be deleted, the indicators will be restored to the investigation and will be considered in the risk calculation. Are you sure?'
    },
    [this.INSIGHT_STATUSES.DISMISSED]: {
        status: this.INSIGHT_STATUSES.DISMISSED,
        filterLabel: 'Dismissed',
        label: 'Dismiss',
        description: 'This insight is not relevant to selected items. Remove the risk indicator.',
        confirmationText:
            'If you approve this action, the selected entities will be removed from this list. In addition, this risk indicator will not be part of this investigation, and will not be considered in risk level calculation of these entities. Are you sure? '
    },
    [this.INSIGHT_STATUSES.HIDDEN]: {
        status: this.INSIGHT_STATUSES.HIDDEN,
        filterLabel: 'Hidden',
        label: 'Hide',
        description:
            'No need to show selected items for this Insight. It will still be considered in the risk assessment.',
        confirmationText:
            'If you approve this action, the selected entities will be removed from this list. However, this insight will still be considered in the risk level calculation of these entities. Are you sure? '
    }
};

exports.UNSAVED_MESSAGE = 'You have some unsaved changes. Are you sure you want to leave?';

exports.SEARCH_MIN_CHARS = 2;

exports.SEARCH_DEBOUNCE_DELAY = 400;

exports.PACKET_FWD_ADDRESS_OPTIONS = {
    subnet: { value: 'subnet', label: 'IP Or Subnet' },
    range: { value: 'range', label: 'Range' }
};

exports.PACKET_FWD_TYPE_OPTIONS = {
    source: { value: 'source', label: 'Source' },
    dest: { value: 'dest', label: 'Destinations' }
};

exports.PACKET_FWD_PROTOCOL_OPTIONS = {
    kerberos: { value: 'kerberos', label: 'Kerberos' },
    ldap: { value: 'ldap', label: 'LDAP' },
    ldaps: { value: 'ldaps', label: 'LDAPS' },
    ntlm: { value: 'ntlm', label: 'NTLM' }
};

exports.TIME_RANGE_OPTIONS = {
    LAST_HOUR: { label: 'Last hour', value: 1, subValue: 1, timeUnit: 'h' },
    LAST_DAY: { label: 'Last Day', value: 2, subValue: 1, timeUnit: 'd' },
    LAST_WEEK: { label: 'Last Week', value: 3, subValue: 1, timeUnit: 'w' }
};

exports.THIRD_PARTY_TEST_MSG = 'Silverfort - Test Connection';

exports.DENY_REASONS = {
    'bad-username': 'Bad username',
    'bad-password': 'Bad password',
    'bad-credentials': 'Bad credentials',
    'outside-hours': 'Outside authorized hours',
    'unauthorized-workstation': 'Unauthorized workstation',
    'expired-password': 'Expired password',
    'account-disabled': 'Account disabled by administrator',
    'expired-account': 'Expired account',
    'change-password-required': 'Changing password is required',
    'windows-bug': 'Bug in Windows, not a risk',
    'locked-account': 'Locked account',
    'missing-secret': 'Missing secret material for account',
    'no-logon-workstation-trust-account': 'Remote authentication is not allowed with this computer account',
    'expired-server': 'Expired server',
    'bad-server': 'Bad server',
    'duplicate-principal': 'Duplicate principal names exist',
    'account-revoked': 'Account disabled, expired or locked out',
    'unavailable-kdc': 'KDS is unavailable',
    'expired-ticket': 'Expired ticket',
    'not-yet-valid-ticket': 'Ticket is not yet valid',
    'bad-realm': 'Bad realm',
    'too-big-clock-skew': 'Clock skew is too great',
    'generic-failure-krb': 'Generic kerberos failure',
    'missing-ticket': 'Missing ticket',
    'denied-conditional-access-applied': 'Conditional access applied',
    '0x3': 'Requested Kerberos version number not supported',
    '0x4': "Client's key encrypted in old master key",
    '0x5': "Server's key encrypted in old master key",
    '0x9': 'The client or server has a null key (master key)',
    '0xa': 'Ticket (TGT) not eligible for postdating',
    '0xb': 'Requested start time is later than end time',
    '0xc': 'Requested start time is later than end time',
    '0xd': 'KDC cannot accommodate requested option',
    '0xe': 'KDC has no support for encryption type',
    '0xf': 'KDC has no support for checksum type',
    '0x10': 'KDC has no support for PADATA type (pre-authentication data)',
    '0x11': 'KDC has no support for transited type',
    '0x13': 'Credentials for server have been revoked',
    '0x14': 'TGT has been revoked',
    '0x15': 'Client not yet valid—try again later',
    '0x16': 'Server not yet valid—try again later',
    '0x1b': 'Server principal valid for user2user only',
    '0x1f': 'Integrity check on decrypted field failed',
    '0x22': 'The request is a replay',
    '0x24': 'The ticket and authenticator do not match',
    '0x26': "Network address in network layer header doesn't match address inside ticket",
    '0x27': "Protocol version numbers don't match (PVNO)",
    '0x28': 'Message type is unsupported',
    '0x29': "Message stream modified and checksum didn't match",
    '0x2a': 'Message out of order (possible tampering)',
    '0x2c': 'Specified version of key is not available',
    '0x2d': 'Service key not available',
    '0x2e': 'Mutual authentication failed',
    '0x2f': 'Incorrect message direction',
    '0x30': 'Alternative authentication method required',
    '0x31': 'Incorrect sequence number in message',
    '0x32': 'Inappropriate type of checksum in message (checksum may be unsupported)',
    '0x33': 'Desired path is unreachable',
    '0x34': 'Too much data',
    '0x3d': 'Field is too long for this implementation',
    '0x3e': 'The client trust failed or is not implemented',
    '0x3f': 'The KDC server trust failed or could not be verified',
    '0x40': 'The signature is invalid',
    '0x41': 'A higher encryption level is needed',
    '0x42': 'User-to-user authorization is required',
    568: 'Too many security IDs were accumulated',
    '0xc0000022': 'The application was unable to start correctly',
    '0xc000005e': 'No logon servers available',
    '0xc00000dc': 'Sam server was in wrong state',
    '0xc0000133': 'Clock between DC and client too far out of sync',
    '0xc000015b': 'User not granted the request logon type',
    '0xc000018c': 'No trust relationship between primary and trusted domains',
    '0xc0000192': 'Netlogon service was not started',
    '0xc00002ee': 'An error occurred during logon',
    '0xc0000413': 'Machine is protected by authentication firewall',
    AADSTS7000112: 'UnauthorizedClientApplicationDisabled - The application is disabled.',
    AADSTS7000222:
        '"InvalidClientSecretExpiredKeysProvided - The provided client secret keys are expired. Visit the Azure portal to create new keys for your app, or consider using certificate credentials for added security: https://aka.ms/certCreds"',
    AADSTS700020: 'InteractionRequired - The access grant requires interaction.',
    AADSTS130007: 'NgcDeviceIsDisabled - The device is disabled.',
    AADSTS120020: 'PasswordChangeFailure',
    AADSTS90125:
        "DebugModeEnrollTenantNotFound - The user isn't in the system. Make sure you entered the user name correctly.",
    AADSTS90120: 'InvalidDeviceFlowRequest - The request was already authorized or declined.',
    AADSTS90094: 'AdminConsentRequired - Administrator consent is required.',
    AADSTS90090: 'GraphRetryableError - The service is temporarily unavailable.',
    AADSTS90084: "OrgIdWsFederationGuestNotAllowed - Guest accounts aren't allowed for this site.",
    AADSTS90043: 'NationalCloudAuthCodeRedirection - The feature is disabled.',
    AADSTS90012: 'RequestTimeout - The requested has timed out.',
    AADSTS90006: 'ExternalServerRetryableError - The service is temporarily unavailable.',
    AADSTS81012:
        'DesktopSsoMismatchBetweenTokenUpnAndChosenUpn - The user trying to sign in to Entra ID is different from the user signed into the device.',
    AADSTS80012:
        'OnPremisePasswordValidationAccountLogonInvalidHours - The users attempted to log on outside of the allowed hours (this is specified in AD).',
    AADSTS70019: 'CodeExpired - Verification code expired. Have the user retry the sign-in.',
    AADSTS53003:
        'BlockedByConditionalAccess - Access has been blocked by Conditional Access policies. The access policy does not allow token issuance.',
    AADSTS53004:
        'ProofUpBlockedDueToRisk - User needs to complete the multi-factor authentication registration process before accessing this content. User should register for multi-factor authentication.',
    AADSTS53002:
        'ApplicationUsedIsNotAnApprovedApp - The app used is not an approved app for Conditional Access. User needs to use one of the apps from the list of approved apps to use in order to get access.',
    AADSTS51000: 'RequiredFeatureNotEnabled - The feature is disabled.',
    AADSTS50144:
        "InvalidPasswordExpiredOnPremPassword - User's Active Directory password has expired. Generate a new password for the user or have the user use the self-service reset tool to reset their password.",
    AADSTS50135: 'PasswordChangeCompromisedPassword - Password change is required due to account risk.',
    AADSTS50132:
        'SsoArtifactInvalidOrExpired - The session is not valid due to password expiration or recent password change.',
    AADSTS50133: 'SsoArtifactRevoked - The session is not valid due to password expiration or recent password change.',
    AADSTS50125:
        'PasswordResetRegistrationRequiredInterrupt - Sign-in was interrupted because of a password reset or password registration entry.',
    AADSTS50126: 'InvalidUserNameOrPassword - Error validating credentials due to invalid username or password.',
    AADSTS50087: 'SasRetryableError - The service is temporarily unavailable. Try again.',
    AADSTS50089:
        'Flow token expired - Authentication Failed. Have the user try signing-in again with username -password.',
    AADSTS50097: 'DeviceAuthenticationRequired - Device authentication is required.',
    AADSTS50079:
        '"UserStrongAuthEnrollmentRequired - Due to a configuration change made by the administrator, or because the user moved to a new location, the user is required to use multi-factor authentication."',
    AADSTS50072:
        'UserStrongAuthEnrollmentRequiredInterrupt - User needs to enroll for second factor authentication (interactive).',
    AADSTS50074:
        'UserStrongAuthClientAuthNRequiredInterrupt - Strong authentication is required and the user did not pass the MFA challenge.',
    AADSTS50076:
        '"UserStrongAuthClientAuthNRequired - Due to a configuration change made by the admin, or because you moved to a new location, the user must use multi-factor authentication to access the resource. Retry with a new authorize request for the resource."',
    AADSTS50064: 'CredentialAuthenticationError - Credential validation on username or password has failed.',
    AADSTS50057: 'UserDisabled - The user account is disabled. The account has been disabled by an administrator.',
    AADSTS50055: 'InvalidPasswordExpiredPassword - The password is expired.',
    AADSTS50053:
        'IdsLocked - The account is locked because the user tried to sign in too many times with an incorrect user ID or password.',
    AADSTS50029: 'Invalid URI - domain name contains invalid characters. Contact the tenant admin.',
    AADSTS50008:
        'InvalidSamlToken - SAML assertion is missing or misconfigured in the token. Contact your federation provider.',
    AADSTS50001:
        "InvalidResource - The resource is disabled or does not exist. Check your app's code to ensure that you have specified the exact resource URL for the resource you are trying to access.",
    AADSTS50002:
        '"NotAllowedTenant - Sign-in failed because of a restricted proxy access on the tenant. If it\'s your own tenant policy, you can change your restricted tenant settings to fix this issue."',
    AADSTS50155: '"DeviceAuthenticationFailed - Device authentication failed for this user."'
};

exports.ALLOW_REASONS = {
    'approved-conditional-access-applied': 'Conditional access applied'
};

exports.SAN_EXTENSION_ID = '2.5.29.17';

exports.BUILT_IN_AZURE_APPS = {
    '4765445b-32c6-49b0-83e6-1d93765276ca': 'Office.com',
    '0ec893e0-5785-4de6-99da-4ed124e5296c': 'Office desktop',
    '23523755-3a2b-41ca-9315-f81f3f566a95': 'ACOM Azure Website',
    'e9f49c6b-5ce5-44c8-925d-015017e9f7ad': 'Azure Data Lake',
    '835b2a73-6e10-4aa5-a979-21dfda45231c': 'Azure Lab Services Portal',
    'c44b4083-3bb0-49c1-b47d-974e53cbdf3c': 'Azure Portal',
    '37182072-3c9c-4f6a-a4b3-b3f91cacffce': 'AzureSupportCenter',
    '9ea1ad79-fdb6-4f9a-8bc3-2b70f96e34c7': 'Bing',
    '00000007-0000-0000-c000-000000000000': 'Common Data Service',
    'bb2a2e3a-c5e7-4f0a-88e0-8e01fd3fc1f4': 'CPIM Service',
    'e64aa8bc-8eb4-40e2-898b-cf261a25954f': 'CRM Power BI Integration',
    '60c8bde5-3167-4f92-8fdb-059f6176dc0f': 'Enterprise Roaming and Backup',
    'a57aca87-cbc0-4f3c-8b9e-dc095fdc8978': 'IAM Supportability',
    '16aeb910-ce68-41d1-9ac3-9e1673ac9575': 'IrisSelectionFrontDoor',
    'd73f4b35-55c9-48c7-8b10-651f6f2acb2e': 'MCAPI Authorization Prod',
    '944f0bd1-117b-4b1c-af26-804ed95e767e': 'Media Analysis and Transformation Service',
    '0cd196ee-71bf-4fd6-a57c-b491ffd4fb1e': 'Media Analysis and Transformation Service',
    'ee272b19-4411-433f-8f28-5c13cb6fd407': 'Microsoft 365 Support Service',
    '0000000c-0000-0000-c000-000000000000': 'Microsoft App Access Panel',
    '65d91a3d-ab74-42e6-8a2f-0add61688c74': 'Microsoft Approval Management',
    '38049638-cc2c-4cde-abe4-4479d721ed44': 'Microsoft Approval Management',
    '29d9ed98-a469-4536-ade2-f981bc1d605e': 'Microsoft Authentication Broker',
    '04b07795-8ddb-461a-bbee-02f9e1bf7b46': 'Microsoft Azure CLI',
    'cf36b471-5b44-428c-9ce7-313bf84528de': 'Microsoft Bing Search',
    '2d7f3606-b07d-41d1-b9d2-0d0c9296a6e8': 'Microsoft Bing Search for Microsoft Edge',
    '1786c5ed-9644-47b2-8aa0-7201292175b6': 'Microsoft Bing Default Search Engine',
    '3090ab82-f1c1-4cdf-af2c-5d7a6f3e2cc7': 'Microsoft Cloud App Security',
    '18fbca16-2224-45f6-85b0-f7bf2b39b3f3': 'Microsoft Docs',
    '00000015-0000-0000-c000-000000000000': 'Microsoft Dynamics ERP',
    '6253bca8-faf2-4587-8f2f-b056d80998a7': 'Microsoft Edge Insider Addons Prod',
    '00000007-0000-0ff1-ce00-000000000000': 'Microsoft Exchange Online Protection',
    'c9a559d2-7aab-4f13-a6ed-e7e9c52aec87': 'Microsoft Forms',
    '00000003-0000-0000-c000-000000000000': 'Microsoft Graph',
    '74bcdadc-2fdc-4bb3-8459-76d06952a0e9': 'Microsoft Intune Web Company Portal',
    'fc0f3af4-6835-4174-b806-f7db311fd2f3': 'Microsoft Intune Windows Agent',
    'd3590ed6-52b3-4102-aeff-aad2292ab01c': 'Microsoft Office',
    '00000006-0000-0ff1-ce00-000000000000': 'Microsoft Office 365 Portal',
    '67e3df25-268a-4324-a550-0de1c7f97287': 'Microsoft Office Web Apps Service',
    'd176f6e7-38e5-40c9-8a78-3998aab820e7': 'Microsoft Online Syndication Partner Portal',
    '93625bc8-bfe2-437a-97e0-3d0060024faa': 'Microsoft password reset service',
    '871c010f-5e61-4fb1-83ac-98610a7e9110': 'Microsoft Power BI',
    '28b567f6-162c-4f54-99a0-6887f387bbcc': 'Microsoft Storefronts',
    'cf53fce8-def6-4aeb-8d30-b158e7b1cf83': 'Microsoft Stream Portal',
    '98db8bd6-0cc0-4e67-9de5-f187f1cd1b41': 'Microsoft Substrate Management',
    'fdf9885b-dd37-42bf-82e5-c3129ef5a302': 'Microsoft Support',
    '1fec8e78-bce4-4aaf-ab1b-5451cc387264': 'Microsoft Teams',
    'cc15fd57-2c6c-4117-a88c-83b1d56b4bbe': 'Microsoft Teams Services',
    '5e3ce6c0-2b1f-4285-8d4b-75ee78787346': 'Microsoft Teams Web Client',
    '95de633a-083e-42f5-b444-a4295d8e9314': 'Microsoft Whiteboard Services',
    '4345a7b9-9a63-4910-a426-35363201d503': 'O365 Suite UX',
    '00000002-0000-0ff1-ce00-000000000000': 'Office 365 Exchange Online',
    '00b41c95-dab0-4487-9791-b9d2c32c80f2': 'Office 365 Management',
    '66a88757-258c-4c72-893c-3e8bed4d6899': 'Office 365 Search Service',
    '00000003-0000-0ff1-ce00-000000000000': 'Office 365 SharePoint Online',
    '94c63fef-13a3-47bc-8074-75af8c65887a': 'Office Delve',
    '93d53678-613d-4013-afc1-62e9e444a0a5': 'Office Online Add-in SSO',
    '2abdc806-e091-4495-9b10-b04d93c3f040': 'Office Online Client AAD- Augmentation Loop',
    'b23dd4db-9142-4734-867f-3577f640ad0c': 'Office Online Client AAD- Loki',
    '17d5e35f-655b-4fb0-8ae6-86356e9a49f5': 'Office Online Client AAD- Maker',
    'b6e69c34-5f1f-4c34-8cdf-7fea120b8670': 'Office Online Client MSA- Loki',
    '243c63a3-247d-41c5-9d83-7788c43f1c43': 'Office Online Core SSO',
    'a9b49b65-0a12-430b-9540-c80b3332c127': 'Office Online Search',
    '4b233688-031c-404b-9a80-a4f3f2351f90': 'Office.com',
    '89bee1f7-5e6e-4d8a-9f3d-ecd601259da7': 'Office365 Shell WCSS-Client',
    '0f698dd4-f011-4d23-a33e-b36416dcb1e6': 'OfficeClientService',
    '4d5c2d63-cf83-4365-853c-925fd1a64357': 'OfficeShredderWacClient',
    'ab9b8c07-8f02-4f72-87fa-80105867a763': 'OneDrive SyncEngine',
    '2d4d3d8e-2be3-4bef-9f87-7875a61c29de': 'OneNote',
    '27922004-5251-4030-b22d-91ecd9a37ea4': 'Outlook Mobile',
    '00000009-0000-0000-c000-000000000000': 'Power BI Service',
    'ffcb16e8-f789-467c-8ce9-f826a080d987': 'SharedWithMe',
    '08e18876-6177-487e-b8b5-cf950c1e598c': 'SharePoint Online Web Client Extensibility',
    'b4bddae8-ab25-483e-8670-df09b9f1d0ea': 'Signup',
    '00000004-0000-0ff1-ce00-000000000000': 'Skype for Business Online',
    '905fcf26-4eb7-48a0-9ff0-8dcc7194b5ba': 'Sway',
    '268761a2-03f3-40df-8a8b-c3db24145b6b': 'Universal Store Native Client',
    '5572c4c0-d078-44ce-b81c-6cbf8d3ed39e': 'Vortex [wsfed enabled]',
    '00000002-0000-0000-c000-000000000000': 'Windows Azure Active Directory',
    '797f4846-ba00-4fd7-ba43-dac1f8f63013': 'Windows Azure Service Management API',
    'a3b79187-70b2-4139-83f9-6016c58cd27b': 'WindowsDefenderATP Portal',
    '26a7ee05-5602-4d76-a7ba-eae8b7b67941': 'Windows Search',
    '1b3c667f-cde3-4090-b60b-3d2abd0117f0': 'Windows Spotlight',
    '45a330b1-b1ec-4cc1-9161-9f03992aa49f': 'Windows Store for Business',
    '00000005-0000-0ff1-ce00-000000000000': 'Yammer',
    'c1c74fed-04c9-4704-80dc-9f79a2e515cb': 'Yammer Web',
    'e1ef36fd-b883-4dbf-97f0-9ece4b576fc6': 'Yammer Web Embed',
    'cb1056e2-e479-49de-ae31-7812af012ed8': 'Pass-through authentication',
    'a0c73c16-a7e3-4564-9a95-2bdf47383716': 'EXO Remote PowerShell',
    '389b1b32-b5d5-43b2-bddc-84ce938d6737': 'Office Management API Editor',
    '9bc3ab49-b65d-410a-85ad-de819febfddc': 'SPO',
    '6c7e8096-f593-4d72-807f-a5f86dcc9c77': 'MAM',
    '0c1307d4-29d6-4389-a11c-5cbe7f65d7fa': 'Azure Android App',
    '4813382a-8fa7-425e-ab75-3b753aab3abb': 'Microsoft authenticator'
};

exports.MFA_TEST_BUTTON_VENDERS = {
    Duo: { label: 'Duo Push', tooltip: null },
    RSA: { label: 'SecurID Push ', tooltip: null },
    Okta: { label: 'Okta Verify Push ', tooltip: null },
    Ping: { label: 'PingID Push', tooltip: null },
    Microsoft: { label: 'Microsoft Authenticator Push', tooltip: null },
    Hypr: { label: 'HYPR Push', tooltip: null }
};

exports.MFA_TEST_BUTTON_STRING = 'Test';

exports.MISSING_API_USER_ERROR = 'The Silverfort MFA API User is not defined.';

exports.ELASTIC_ENTITIES_INDEX_NAME = 'entities';

exports.ELASTIC_BULK_SIZE = 10000;

exports.TIME_TYPES = {
    MINUTES: { label: 'Minutes', value: 1000 * 60, max: 90, min: 1 },
    HOURS: { label: 'Hours', value: 1000 * 60 * 60, max: 24, min: 1 }
};

exports.REGEX_SPECIAL_CHARS = ['.', '^', '$', '*', '+', '-', '?', '(', ')', '[', ']', '{', '}', '', '|', '—', '/'];

exports.RESOURCE_TYPES = {
    AD: 'ad',
    AD_USER_WITH_SPN: 'uws',
    PINGFED: 'pingfed',
    ADFS: 'adfs',
    OKTA: 'okta'
};
exports.RESOURCE_TYPES_TO_PROTOCOL = {
    pingfed: 'PING_ADAPTER',
    adfs: 'ADFS'
};

exports.REVOKED_TOKENS_HASH = 'revoked_tokens';

exports.IDENTIFIER_FIELD_OPTIONS = {
    UPN: { value: 'userPrincipalName', label: 'User Principal Name' },
    EMAIL: { value: 'mail', label: 'E-Mail' },
    SAM_ACCOUNT: { value: 'sAMAccountName', label: 'SAM Account' }
};

exports.FEATURE_FLAG_SEVERITIES = {
    DISABLED: 'disabled',
    PASSIVE: 'passive',
    ACTIVE: 'active'
};

exports.FEATURE_FLAG_TYPES = {
    RELEASE: 'release',
    OPS: 'ops',
    LICENSE: 'license'
};

exports.FEATURE_FLAGS_NAMES = {
    GeoLocationEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.GeoLocationEnabled`,
    MultiDomainEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.MultiDomainEnabled`,
    IncidentsEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.IncidentsEnabled`,
    InvestigationExpenderEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.InvestigationExpenderEnabled`,
    ServiceAccountBulkAssignEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.ServiceAccountBulkAssignEnabled`,
    NewInsightsMechanismReadEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.NewInsightsMechanismReadEnabled`,
    NewInsightsMechanismWriteEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.NewInsightsMechanismWriteEnabled`,
    SystemBackupEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.SystemBackupEnabled`,
    NewADConnectors: `${this.FEATURE_FLAG_TYPES.OPS}.NewADConnectors`,
    SystemMode: `${this.FEATURE_FLAG_TYPES.OPS}.SystemMode`,
    FiltersChatBot: `${this.FEATURE_FLAG_TYPES.OPS}.FiltersChatBot`,
    AutoDetectDeletedObjectsMode: `${this.FEATURE_FLAG_TYPES.OPS}.AutoDetectDeletedObjects`,
    ServiceAccountAutoProtect: `${this.FEATURE_FLAG_TYPES.OPS}.ServiceAccountAutoProtect`,
    AccessAnalysisEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.AccessAnalysisEnabled`,
    AccessAnalysisBatchQueue: `${this.FEATURE_FLAG_TYPES.OPS}.AccessAnalysisBatchQueue`,
    CalcTierClassificationEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.CalcTierClassificationEnabled`,
    PasTier2: `${this.FEATURE_FLAG_TYPES.OPS}.PasTier2`,
    BridgeSSOLoginHint: `${this.FEATURE_FLAG_TYPES.OPS}.BridgeSSOLoginHint`,
    NewServiceAccountUI: `${this.FEATURE_FLAG_TYPES.OPS}.NewServiceAccountUI`,
    NewADSync: `${this.FEATURE_FLAG_TYPES.OPS}.NewADSync`,
    AIAgentsVisibility: `${this.FEATURE_FLAG_TYPES.OPS}.AIAgentsVisibility`,
    ProtectionGroupsManagerEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.ProtectionGroupsManagerEnabled`,
    DashboardAnimations: `${this.FEATURE_FLAG_TYPES.OPS}.DashboardAnimations`,
    CloudResources: `${this.FEATURE_FLAG_TYPES.OPS}.CloudResources`,
    HideBlockedPagesMenuItems: `${this.FEATURE_FLAG_TYPES.OPS}.HideBlockedPagesMenuItems`,
    HidePoliciesBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HidePoliciesBlockedPageMenuItem`,
    HideUserManagementBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideUserManagementBlockedPageMenuItem`,
    HidePrivilegedAccountsBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HidePrivilegedAccountsBlockedPageMenuItem`,
    HideServiceAccountsBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideServiceAccountsBlockedPageMenuItem`,
    HideIspmBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideIspmBlockedPageMenuItem`,
    HideItdrBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideItdrBlockedPageMenuItem`,
    HideAccessAnalysisBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideAccessAnalysisBlockedPageMenuItem`,
    HideLogsBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideLogsBlockedPageMenuItem`,
    HideAISecurityBlockedPageMenuItem: `${this.FEATURE_FLAG_TYPES.OPS}.HideAISecurityBlockedPageMenuItem`,
    ForceBackupForSaasSupport: `${this.FEATURE_FLAG_TYPES.OPS}.ForceBackupForSaasSupport`,
    PasFencingSupportUnresolved: `${this.FEATURE_FLAG_TYPES.OPS}.PasFencingSupportUnresolved`,
    SaFencingSupportUnresolved: `${this.FEATURE_FLAG_TYPES.OPS}.SaFencingSupportUnresolved`,
    AccordingToIp: `${this.FEATURE_FLAG_TYPES.OPS}.AccordingToIp`,
    WallJobsWebSocketFallbackEnabled: `${this.FEATURE_FLAG_TYPES.OPS}.WallJobsWebSocketFallbackEnabled`,
    ShouldCollectAuthenticationTuples: `${this.FEATURE_FLAG_TYPES.OPS}.ShouldCollectAuthenticationTuples`,
    OldRiskReportGeneration: `${this.FEATURE_FLAG_TYPES.OPS}.OldRiskReportGeneration`,
    AIAssistant: `${this.FEATURE_FLAG_TYPES.OPS}.AIAssistant`
};

exports.FEATURE_FLAGS_DEFAULTS = {
    ...Object.values(this.FEATURE_FLAGS_NAMES).reduce(
        (obj, name) => ({ ...obj, [name]: this.FEATURE_FLAG_SEVERITIES.DISABLED }),
        {}
    ),
    [this.FEATURE_FLAGS_NAMES.GeoLocationEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.IncidentsEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.InvestigationExpenderEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.ServiceAccountBulkAssignEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.MultiDomainEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.SystemBackupEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.NewADConnectors]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.AutoDetectDeletedObjectsMode]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.NewInsightsMechanismReadEnabled]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.NewInsightsMechanismWriteEnabled]: this.FEATURE_FLAG_SEVERITIES.PASSIVE,
    [this.FEATURE_FLAGS_NAMES.NewInsightsMechanismReadEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.NewInsightsMechanismWriteEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.FiltersChatBot]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.ServiceAccountAutoProtect]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.SystemBackupEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.CalcTierClassificationEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.PasTier2]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.NewServiceAccountUI]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.ShouldCollectAuthenticationTuples]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.AccessAnalysisEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.AIAgentsVisibility]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.ProtectionGroupsManagerEnabled]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.DashboardAnimations]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.AccessAnalysisBatchQueue]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.NewADSync]: this.FEATURE_FLAG_SEVERITIES.ACTIVE,
    [this.FEATURE_FLAGS_NAMES.HideBlockedPagesMenuItems]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HidePoliciesBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideUserManagementBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HidePrivilegedAccountsBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideServiceAccountsBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideIspmBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideItdrBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideAccessAnalysisBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideLogsBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.HideAISecurityBlockedPageMenuItem]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.ForceBackupForSaasSupport]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.PasFencingSupportUnresolved]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.SaFencingSupportUnresolved]: this.FEATURE_FLAG_SEVERITIES.DISABLED,
    [this.FEATURE_FLAGS_NAMES.WallJobsWebSocketFallbackEnabled]: this.FEATURE_FLAG_SEVERITIES.DISABLE,
    [this.FEATURE_FLAGS_NAMES.OldRiskReportGeneration]: this.FEATURE_FLAG_SEVERITIES.DISABLED
};

exports.CAPTURE_FILE_PREFIX = 'capture_file_';

exports.JIT_SUPPORTED_PROTOCOLS = {
    KERBEROS: 'kerberos',
    NTLM: 'ntlm',
    LDAP: 'ldap',
    LDAPS: 'ldaps',
    DESKTOP: 'desktop'
};

exports.CAPTURE_PROTOCOLS_OPTIONS = {
    KERBEROS: { value: 'kerberos', label: 'Kerberos' },
    NTLM: { value: 'ntlm', label: 'NTLM' },
    LDAP: { value: 'ldap', label: 'LDAP' },
    LDAPS: { value: 'ldaps', label: 'LDAPS' }
};

exports.INCIDENT_SEVERITY = {
    CRITICAL: { value: 4, label: 'critical' },
    HIGH: { value: 3, label: 'high' },
    MEDIUM: { value: 2, label: 'medium' },
    LOW: { value: 1, label: 'low' }
};

const LOG_TYPE = {
    AUTHENTICATION: 1,
    EVENTS_LOG: 2
};

exports.LOG_TYPE = LOG_TYPE;

exports.INCIDENT_TYPE = {
    BRUTE_FORCE: {
        value: 0,
        guiName: 'Brute Force',
        description:
            'Detects multiple authentication failures in a short period. May indicate brute-force or credential-stuffing.',
        label: 'UserBruteforce',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'BRUTE_FORCE'
    },
    LATERAL_MOVEMENT: {
        value: 1,
        guiName: 'Lateral Movement Advance Path',
        description:
            'Detects sequential authentications between different systems. May indicate attacker progression through the network post-compromise.',
        label: 'LateralMovement',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'LATERAL_MOVEMENT'
    },
    NO_PAC: {
        value: 2,
        guiName: 'NoPac Breach',
        description:
            'Detects TGT requests from accounts mimicking DCs. May indicate CVE-2021-42278/42287 exploitation.',
        label: 'NoPacBreach',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'NOPAC_BREACH'
    },
    LOG4SHELL: {
        value: 3,
        guiName: 'Log4Shell Exploit Attempt',
        description:
            'Detects authentication identifiers containing {jndi}. May indicate Log4Shell exploitation attempt.',
        label: 'Log4Shell',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'LOG4SHELL'
    },
    CREDENTIAL_SCANNING: {
        value: 4,
        guiName: 'Credential Scanning',
        description:
            'Detects multiple failed login attempts to the same server from several different accounts within a short time period. May indicate credential scanning or early-stage brute-force activity.',
        label: 'CredentialScanning',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'CREDENTIAL_SCANNING'
    },
    WHITE_CANE: {
        value: 5,
        guiName: 'Lateral Movement Search Path',
        description:
            'Detects bursts of authentications from one host to many others. May indicate reconnaissance for lateral movement targets.',
        label: 'WhiteCane',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'WHITE_CANE'
    },
    CERTIFRIED: {
        value: 6,
        guiName: 'Certifried Exploit Attempt',
        description:
            'Detects Kerberos certificate authentications by DC accounts. May indicate ADCS misconfiguration abuse (CVE-2022-26923).',
        label: 'Certifried',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'CERTIFRIED'
    },
    SUSPICIOUS_DENIED_MFA: {
        value: 7,
        guiName: 'User Denied Suspicious Authentications',
        description:
            'Detects denied MFA with other risk indicators (e.g., new host, impossible travel). May indicate user rejection of unauthorized access.',
        label: 'SuspiciousDeniedMfa',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'SUSPICIOUS_DENIED_MFA'
    },
    AS_REP_ROASTING: {
        value: 8,
        guiName: 'AS-REP Roasting',
        description:
            'Detects AS-REQ messages without pre-authentication accepted by the domain controller. May indicate collection of AS-REP responses for offline password cracking.',
        label: 'AsRepRoasting',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'AS_REP_ROASTING'
    },
    SMB_ENUMERATION: {
        value: 9,
        guiName: 'SMB Enumeration',
        description: 'Detects unusually high access to CIFS servers. May indicate reconnaissance of shared resources.',
        label: 'SmbEnumeration',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'SMB_ENUMERATION'
    },
    BAD_CHECKSUM: {
        value: 10,
        guiName: 'Bad Checksum in Kerberos',
        description:
            'Detects Kerberos authentication failures from checksum mismatches. May indicate tampering or forged packets.',
        label: 'BadChecksum',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'BAD_CHECKSUM'
    },
    MALICIOUS_IP: {
        value: 11,
        guiName: 'Malicious IP',
        description:
            'Detects authentications from IPs flagged as malicious. May indicate attacker-controlled infrastructure.',
        label: 'MaliciousIp',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'MALICIOUS_IP'
    },
    IMPOSSIBLE_TRAVEL: {
        value: 12,
        guiName: 'Impossible Travel',
        description: 'Detects logins from distant locations within a short time. May indicate credential compromise.',
        label: 'ImpossibleTravel',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'IMPOSSIBLE_TRAVEL'
    },
    MFA_REQUEST_GENERATION: {
        value: 13,
        guiName: 'MFA Request Generation (MFA Bombing)',
        description: 'Detects repeated denied MFA prompts. May indicate attacker coercing user approval.',
        label: 'MfaRequestGeneration',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'MFA_REQUEST_GENERATION'
    },
    PAYLOAD_INJECTION: {
        value: 14,
        guiName: 'Payload Injection',
        description:
            'Detects suspicious username patterns (e.g., long or special-character inputs). May indicate malicious input injection.',
        label: 'PayloadInjection',
        incidentType: LOG_TYPE.AUTHENTICATION,
        apiName: 'PAYLOAD_INJECTION'
    },
    KERBEROASTING: {
        value: 15,
        guiName: 'Suspected Kerberoasting',
        description:
            'Detects weakly encrypted service ticket requests. May indicate SPN ticket harvesting for brute-force attacks.',
        label: 'Kerberoasting',
        apiName: 'KERBEROASTING',
        incidentType: LOG_TYPE.AUTHENTICATION
    },
    REMOTE_SERVICE_INSTALLATION: {
        value: 16,
        guiName: 'Remote Service Installation',
        label: 'RemoteServiceInstallation',
        description:
            'Detects the creation of new system services on a host. May indicate remote code execution using tools like PSExec or PAExec.',
        incidentType: LOG_TYPE.EVENTS_LOG,
        apiName: 'REMOTE_SERVICE_INSTALLATION'
    },
    PRIVILEGED_GROUP_MEMBER_ADDITION: {
        value: 18,
        guiName: 'Suspicious Addition to Privileged Group',
        label: 'PrivilegedGroupMemberAddition',
        description:
            'Detects the addition of accounts to privileged security groups. May indicate privilege escalation or persistence attempts.',
        apiName: 'PRIVILEGED_GROUP_MEMBER_ADDITION',
        incidentType: LOG_TYPE.EVENTS_LOG
    },
    SECURITY_LOG_CLEARED: {
        value: 19,
        guiName: 'Security Log Cleared on Domain Controller',
        label: 'SecurityLogCleared',
        description:
            'Detects the clearing of security audit logs on a domain controller. May indicate attempts to hide malicious activity.',
        apiName: 'SECURITY_LOG_CLEARED',
        incidentType: LOG_TYPE.EVENTS_LOG
    },
    NTDS_DIT_DUMP: {
        value: 20,
        guiName: 'Suspicious NTDS.dit Extraction',
        label: 'NtdsDitDump',
        description:
            'Detects access, copy, or exfiltration of the NTDS.dit file on a domain controller. May indicate credential dumping and full domain compromise attempts.',
        apiName: 'NTDS_DIT_DUMP',
        incidentType: LOG_TYPE.EVENTS_LOG
    }
};

exports.INCIDENT_CATEGORY = {
    AUTH_BASE: { value: 0, guiName: 'Authentication based', label: 'AuthBased' }
};

exports.INCIDENT_STATUS = {
    ONGOING: {
        value: 0,
        label: 'Ongoing',
        color: 'sf-negative-500',
        textColor: 'sf-negative-500',
        graphColor: '#F5445A'
    },
    ACKNOWLEDGED: { value: 1, label: 'Acknowledged', color: 'sf-warn', textColor: 'sf-alert', graphColor: '#ea8908' },
    OPEN: { value: 2, label: 'Open', color: 'sf-negative-100', textColor: 'sf-negative-500', graphColor: '#F5445A' },
    IN_PROGRESS: { value: 4, label: 'In progress', color: 'sf-warn', textColor: 'sf-alert', graphColor: '#ea8908' },
    RESOLVED: {
        value: 3,
        label: 'Resolved',
        color: 'sf-positive-100',
        textColor: 'sf-positive-500',
        graphColor: '#00CC96'
    }
};

exports.INCIDENTS_API = {
    GET_INCIDENTS_SUPPORTED_QUERY_PARAMS: new Set([
        'page_number',
        'page_size',
        'fields',
        'status',
        'is_archived',
        'from_start_time',
        'to_end_time',
        'kind',
        'main_entity_guid',
        'main_entity_name',
        'include_excluded'
    ]),
    ALLOWED_FIELDS: [
        'id',
        'kind',
        'start_time',
        'end_time',
        'auth_count',
        'status',
        'is_archived',
        'is_hidden',
        'last_auth_timestamp',
        'main_entities',
        'severity',
        'summary'
    ],
    ACTOR: {
        API: 'API',
        EXTERNAL_API: 'External API'
    }
};

exports.INCIDENT_EVENT_IDENTIFIER_TYPES = {
    GUID: 'guid',
    NAME: 'name',
    IP: 'ip'
};

exports.INCIDENT_FILTER_TYPES = {
    ANY: 'any',
    EXISTS:'exists',
    NOT_ANY:'not_any'
};

exports.SHARED_KEY = 'shared';
exports.UNASSIGNED_KEY = 'unassigned';
exports.DCS_WITH_DOMAIN_KEY = 'dcsWithDomains';

exports.AUTHENTICATION_EXPORT_FIELDS = [
    { label: 'Time', value: 'time_stamp' },
    { label: 'Request ID', value: 'request_id' },
    { label: 'Username', value: 'user_identifier' },
    { label: 'User Domain', value: 'user_domain' },
    { label: 'Source', value: 'host_name' },
    { label: 'IP', value: 'ip_address' },
    { label: 'Service', value: 'service' },
    { label: 'Destination', value: 'destination' },
    { label: 'Destination Domain', value: 'server_domain' },
    { label: 'Risk', value: 'risk' },
    { label: 'Auth Type', value: 'directory_type' },
    { label: 'Protocol', value: 'protocol_type' },
    { label: 'Alert', value: 'alert' },
    { label: 'Silverfort Internal Authentication', value: 'internalAuth' },
    { label: 'Node', value: 'wall_id' },
    { label: 'Domain Controller', value: 'domain_controller' },
    { label: 'Tenant ID', value: 'tenant_id' },
    { label: 'Released', value: 'packet_released' },
    { label: 'IdP Result', value: 'action' },
    { label: 'Silverfort Action', value: 'effective_rule_action' },
    { label: 'Executed Policy', value: 'effective_rule_id' },
    { label: 'MFA Response', value: 'user_response' },
    { label: 'MFA Time', value: 'user_response_interval' },
    { label: 'Token ID', value: 'token_id' },
    { label: 'Authenticator', value: 'authenticator' },
    { label: 'Risk Indicators', value: 'riskIndicators' },
    { label: 'Was it you', value: 'wasItYou' },
    { label: 'Mode', value: 'mode' }
];

exports.SERVICE_ACCOUNT_TYPES = {
    ALL: {
        title: 'All',
        type: 'all',
        description:
            'View all AD service accounts in a single tab for better filtering experience across all categories.'
    },
    MACHINE_TO_MACHINE: {
        title: 'Machine to Machine',
        type: 'service_account',
        description: 'These accounts are used between machines or applications'
    },
    SCANNER: {
        title: 'Scanners',
        type: 'scanner',
        description: 'These accounts are used between a small group of machines and a large group of machines'
    },
    DORMANT: {
        title: 'Dormant',
        type: 'dormant',
        description:
            'Service Accounts with zero authentications. All Service Accounts are categorized as dormant until Silverfort detects authentication'
    },
    HYBRID: {
        title: 'Hybrid',
        type: 'hybrid_account',
        description: 'These accounts handle both user and M2M activities'
    },
    REMOVED: {
        title: 'Discarded',
        type: 'removed',
        description:
            'Accounts hidden or classified as not a Service or Hybrid Account are considered discarded and cannot be protected by a policy. This classification can be reversed',
        showRemovedAccounts: true
    }
};

exports.SERVICE_ACCOUNT_CATEGORY_TYPES = Object.keys(this.SERVICE_ACCOUNT_TYPES);

exports.ALLOWED_CREATE_UPDATE_SERVICE_ACCOUNT_CATEGORY = ['MACHINE_TO_MACHINE', 'HYBRID', 'SCANNER'];

exports.SERVICE_ACCOUNT_TAB_TYPES = {
    ALL: this.SERVICE_ACCOUNT_TYPES.ALL,
    MACHINE_TO_MACHINE: this.SERVICE_ACCOUNT_TYPES.MACHINE_TO_MACHINE,
    HYBRID: this.SERVICE_ACCOUNT_TYPES.HYBRID,
    SCANNER: this.SERVICE_ACCOUNT_TYPES.SCANNER,
    DORMANT: this.SERVICE_ACCOUNT_TYPES.DORMANT,
    REMOVED: this.SERVICE_ACCOUNT_TYPES.REMOVED
};

exports.MAX_FILE_NAME_LENGTH_TO_IMPORT = 128;
exports.CSV_MIMETYPES = ['text/csv', 'application/vnd.ms-excel'];
exports.CSV_EXTENTION = 'csv';
exports.ALLOWED_FILE_CONTENT_TYPES_TO_IMPORT = ['application/json'];
exports.ALLOWED_FILE_EXTENTIONS_TO_IMPORT = ['json'];
exports.ALLOWED_CERT_CONTENT_TYPES_TO_IMPORT = [
    'application/pkix-cert',
    'application/x-x509-ca-cert',
    'application/x-x509-user-cert',
    'application/pkcs7-signature',
    'application/x-pem-file',
    'application/x-pkcs7-certificates',
    'application/pkcs7-mime'
];

exports.ALLOWED_CERT_EXTENTIONS_TO_IMPORT = ['pem', 'crt', 'cer', 'p7b', 'p7c', 'p7s'];
exports.ALLOWED_IMG_CONTENT_TYPES_TO_IMPORT = ['image/png'];
exports.ALLOWED_IMG_EXTENTIONS_TO_IMPORT = ['png'];

exports.SERVICE_ACCOUNT_SELECTOR_SORT_OPTIONS = {
    HITS: 'hits',
    LAST_USE: 'last_use',
    ACTION: 'is_allowed',
    NAME: 'name'
};

exports.RISK_INDICATORS_GROUPS = {
    THREAT_INDICATORS_KEY: 'Threat Indicators',
    ATTACK_SURFACE_MANAGEMENT_KEY: 'Attack Surface Management'
};

exports.SERVICE_ACCOUNT_REPORTS = {
    CURRENT_FILTER: 'currentFilter',
    RESOURCES_REPORT: 'resourcesReport',
    PAM_REPORT: 'pamReport'
};

exports.SERVICE_ACCOUNT_EXPORT_OPTIONS = {
    [this.SERVICE_ACCOUNT_REPORTS.CURRENT_FILTER]: {
        title: 'Generate Current Filter Report',
        downloadTitle: 'Download Current Filter Report',
        reportName: 'Service Account Report',
        tooltip: 'Exports service accounts based on the current filter selection.',
        sendFilter: true,
        filePrefix: 'silverfort',
        filters: {
            csv: {
                predefined: null,
                sendFilter: true,
                entitiesFilter: { includeResourcesData: true, isAllowed: true }
            },
            json: {
                predefined: null,
                sendFilter: true,
                entitiesFilter: null
            }
        },
        supportedReportTypes: {
            csv: true,
            json: true
        }
    },
    [this.SERVICE_ACCOUNT_REPORTS.RESOURCES_REPORT]: {
        title: 'Generate Full Resource Report',
        reportName: 'Resource Report',
        downloadTitle: 'Download Full Resource Report',
        tooltip:
            'Details service accounts source, destination, and protocol data, including policy compliance and indications of activity.',
        filePrefix: 'silverfort_all_resources',
        filters: {
            csv: {
                predefined: { removedAccounts: { exclude: true }, ignoreTypeFilter: true },
                sendFilter: false,
                entitiesFilter: { includeResourcesData: true }
            },
            json: {
                predefined: null,
                sendFilter: false,
                entitiesFilter: null
            }
        },
        supportedReportTypes: {
            csv: true,
            json: false
        }
    },
    [this.SERVICE_ACCOUNT_REPORTS.PAM_REPORT]: {
        title: 'Generate PAM Report',
        downloadTitle: 'Download PAM Report',
        reportName: 'PAM Report',
        tooltip:
            'Lists all service accounts with insights to support integration into a Privileged Access Management solution.',
        filePrefix: 'silverfort_PAM_Report',
        filters: {
            csv: {
                predefined: null,
                sendFilter: false,
                entitiesFilter: null
            },
            json: {
                predefined: null,
                sendFilter: false,
                entitiesFilter: null
            }
        },
        supportedReportTypes: {
            csv: true,
            json: true
        }
    }
};

exports.IP_PATTERN =
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
exports.IP_AND_MASK_PATTERN = /((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}\/([1-9]|[12][0-9]|3[012])$/;
exports.MASK_PATTERN = /^(0?|[1-9]|[12][0-9]|3[012])$/;
exports.OCTET_PATTERN = /^(0+|([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))$/;
exports.FIRST_OCTET_PATTERN = /^(^$|([1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))$/;
exports.DEFAULT_MASK = '32';

exports.USERS_CSV_COLUMN_MAPPING = {
    EMAIL: 'Email',
    UPN: 'UPN',
    SAM_ACC: 'SAM_Account',
    SAM_DOMAIN: 'SAM_Domain',
    DN: 'DN'
};

exports.OTP_TOKENS_CSV_COLUMN_MAPPING = {
    UPN: 'upn',
    SERIAL_NUMBER: 'serial number',
    SECRET_KEY: 'secret key',
    TIME_INTERVAL: 'time interval',
    MANUFACTURER: 'manufacturer',
    MODEL: 'model'
};

exports.USERS_EMAIL_IMPORT_FAILURE_REASONS = {
    ALREADY_EXISTS: 'Email is existing',
    NOT_FOUND: 'Cannot find the user',
    MISSING_DATA: 'Missing data',
    UNEXPECTED_ERROR: 'Internal error',
    INVALID_EMAIL_FORMAT: 'Invalid email format',
    INVALID_TOKEN_LIMIT: 'Invalid token limit',
    INVALID_GUID: 'Invalid guid',
    INVALID_EXTERNAL_EMAIL: 'Invalid external email value'
};

exports.HTTP_RES_STATUS_CODES = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    TIMEOUT: 408,
    CONFLICT: 409,
    UNSUPPORTED_MEDIA_TYPE: 415,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500
};

exports.INCIDENTS_TABLE_COLUMNS = [
    {
        id: 0,
        header: 'Incident ID',
        accesor: 'id',
        sortAccesor: 'id_display'
    },
    {
        id: 1,
        header: 'Type',
        accesor: 'kind'
    },
    {
        id: 2,
        header: 'Main Entity',
        accesor: 'mainEntities'
    },
    {
        id: 3,
        header: 'Start Time',
        accesor: 'start_time'
    },
    {
        id: 4,
        header: 'End Time',
        accesor: 'end_time'
    },
    {
        id: 5,
        header: 'Auth #',
        accesor: 'auth_count'
    },
    {
        id: 6,
        header: 'Status',
        accesor: 'status'
    }
];
exports.HTTP_OPTIONS = {
    REQ_OPTIONS: 'reqOptions',
    REDIRECT_TO_NEW_TAB: 'redirectToNewTab',
    HANDLE_ERRORS: 'handleErrors'
};

exports.PRODUCT_CHANGE_ACTIONS = {
    CREATED: 'created',
    UPDATED: 'updated',
    DELETED: 'deleted'
};

exports.PRODUCT_DATA_TYPES = {
    POLICIES: 'policies',
    INCIDENTS: 'incidents',
    INCIDENTS_CONFIGS: 'incident_type_configs',
    SA_POLICIES: 'service_account_policies',
    SA_DISCARDED: 'discarded_service_accounts',
    INSIGHTS: 'insights',
    EXPOSURES: 'exposures',
    EXPOSURE_TYPE_CONFIG: 'exposure_type_configs',
    DAILY: 'daily',
    SETTINGS: 'settings',
    NODES: 'nodes',
    DOMAINS: 'domains',
    AZS: 'azs',
    CUSTOM_INSIGHTS: 'custom_insights',
    DAILY_POLICIES: 'daily_policies',
    SERVICE_ACCOUNT_API: 'service_account_api',
    PAGES_VIEWS: 'page_views',
    AI_LOGS_USAGE: 'ai_logs_usage',
    SYSLOG_SERVERS: 'syslog_servers',
    WEBHOOKS: 'webhooks',
    WEBHOOKS_DAILY_ALERTS: 'webhooks_daily_alerts',
    SA_SMART_POLICY: 'sa_smart_policy',
    USERS_AGG: 'users_agg',
    VMS: 'vms',
    SHADOW_ADMINS: 'shadow_admins',
    RISK_INSIGHTS: 'risk_insights',
    SYSTEM_STATUS: 'system_status',
    PRIVILEGED_ACCESS_SECURITY: 'pas',
    ASSETS: 'assets',
    ASSETS_SERVICES: 'pas_services',
    EXPLAINABILITY_INSIGHTS_CLICKS: 'insights_clicks',
    POLICIES_API: 'policies_api',
    ACCESS_ANALYSIS: 'access_analysis',
    LOCAL_USERS: 'wl_auths_users',
    SERVICE_ACCOUNTS_OWNERSHIP: 'service_accounts_ownership',
    PAS_SETTINGS: 'settings_pas',
    LICENSE: 'license',
    USER_MANAGEMENT_GENERAL_DATA: 'user_management',
    USER_MANAGEMENT_TOKENS_DATA: 'tokens_user_management',
    USER_MANAGEMENT_SETTINGS_DATA: 'user_management_settings',
    AUTHENTICATION_FIREWALL_DASHBOARD: 'api_policies_dashboard_auth_firewall',
    UNIVERSAL_MFA_DASHBOARD: 'api_policies_dashboard_universal_mfa',
    ADMIN_ACTION_LOCAL_ACCOUNTS: 'admin_action_local_accounts'
};

exports.INVOLVED_ENTITY_TYPES_BY_INCIDENT_TYPE = {
    [this.INCIDENT_TYPE.BRUTE_FORCE.value]: {
        servers: true,
        devices: false,
        users: false
    }
};
exports.BACKUP_RESTORE_TYPES = {
    SETTINGS: 'Settings',
    DATA: 'Data'
};

exports.BACKUP_RESTORE_DATA_OPTIONS = {
    SERVICE_ACCOUNTS: 'Service accounts',
    POLICIES: 'Policies',
    TOKENS: 'Tokens',
    CUSTOM_REPORTS: 'Custom reports'
};

exports.BACKUP_STATUS = {
    READY: 'ready',
    BUSY: 'busy',
    ERROR: 'error'
};

exports.INCIDENT_INVOLVED_ENTITIES_TYPE = {
    SERVERS: 'servers',
    USERS: 'users',
    DEVICES: 'devices'
};

exports.DOMAIN_ADSYNC_FIELDS = {
    NO_DIFF: 'no_diff',
    NO_RISK_DIFF: 'no_risk_diff',
    ADSYNC_FAILED: 'failed_adsync',
    ADSYNC_DIFF: 'ad_sync_diff',
    ADSYNC_INIT_GROUP: 'ad_sync_init_group',
    ADSYNC_INIT_BASIC: 'ad_sync_init_basic',
    RISK_ADSYNC_DIFF: 'risk_ad_sync_diff',
    ADSYNC_INIT_DCS: 'ad_sync_init_dcs'
};

exports.ADSYNC_FILES_TO_FIELDS = {
    ['ad_sync_diff.json']: this.DOMAIN_ADSYNC_FIELDS.ADSYNC_DIFF,
    ['ad_sync_init_group.json']: this.DOMAIN_ADSYNC_FIELDS.ADSYNC_INIT_GROUP,
    ['ad_sync_init_basic.json']: this.DOMAIN_ADSYNC_FIELDS.ADSYNC_INIT_BASIC,
    ['risk_ad_sync_diff.json']: this.DOMAIN_ADSYNC_FIELDS.RISK_ADSYNC_DIFF,
    ['ad_sync_init_dcs.json']: this.DOMAIN_ADSYNC_FIELDS.ADSYNC_INIT_DCS
};

exports.AUTH_LOGS_MAX_DOCS_TO_SEARCH_DEFAULT = 100000;
exports.AUTH_LOGS_MAX_DOCS_TO_SEARCH_LIMIT = 1000000;

exports.SYSTEM_STATUS_TABS_TYPES = {
    NODES: 'NODES',
    DCS: 'DCS',
    PUSH_SERVICES: 'PUSH_SERVICES',
    AD_CONNECT: 'AD_CONNECT',
    ADMIN_CONSOLE: 'ADMIN_CONSOLE'
};

exports.ADSYNC_FILEDS = [
    this.DOMAIN_ADSYNC_FIELDS.NO_DIFF,
    this.DOMAIN_ADSYNC_FIELDS.ADSYNC_DIFF,
    this.DOMAIN_ADSYNC_FIELDS.ADSYNC_INIT_GROUP,
    this.DOMAIN_ADSYNC_FIELDS.ADSYNC_INIT_BASIC,
    this.DOMAIN_ADSYNC_FIELDS.ADSYNC_INIT_DCS
];
exports.ADSYNC_DIFF_FIELDS = [this.DOMAIN_ADSYNC_FIELDS.NO_DIFF, this.DOMAIN_ADSYNC_FIELDS.ADSYNC_DIFF];
exports.RISK_ADSYNC_FIELDS = [this.DOMAIN_ADSYNC_FIELDS.RISK_ADSYNC_DIFF, this.DOMAIN_ADSYNC_FIELDS.NO_RISK_DIFF];

exports.REDUCED_COFIG_EXCLUDED_KEYS = [
    'DomainControllersConfigurations',
    'DomainsConfigurations',
    'TowerCertificateRequest',
    'TowerCertificateData',
    'PushServicesCertificateRequest',
    'PushServicesCertificateData',
    'SSOCertificateData',
    'StunnelKey',
    'StunnelPublicKey',
    'TowerCustomConfigSchema',
    'PolicySchema',
    'OktaAPIToken',
    'OktaUrl',
    'RSAApiKey',
    'DuoIntegrationKey',
    'DuoSecretKey',
    'PingAPIKey',
    'PingToken',
    'PerPolicyVersions'
];

exports.CSV_CELL_MAX_SIZE = 30000; // real max size is 32,767
exports.AD_CONNECT_INSTALLER_FILE_PREFIX = 'Silverfort AD Connect';

exports.LIMITS_CRONS_SCHEDULE = {
    RESET: 'resetCronSchedule',
    CALC: 'calcCronSchedule'
};

exports.SYSTEM_LIMITS_KEYS = {
    AUTH_PEAK: 'auth_peak',
    AUTH_STORAGE: 'auth_storage',
    SIGN_ON_AUTH_PEAK: 'sign_on_auth_peak',
    ACTIVE_POLICIES: 'active_policies',
    CUSTOM_INSIGHTS: 'custom_insights',
    PROTECTED_SERVICE_ACCOUNTS: 'protected_service_accounts',
    USERS: 'users',
    GROUPS: 'groups',
    MEMBERSHIPS: 'memberships',
    DESKTOP_APP: 'desktop_app',
    CONNECTED_DCS: 'connected_dcs',
    RISK_INDICATORS: 'risk_indicators',
    INCIDENTS: 'incidents',
    ONGOING_INCIDENTS: 'ongoing_incidents'
};

exports.SYSTEM_LIMITS_SCHEDULES = {
    [this.SYSTEM_LIMITS_KEYS.AUTH_PEAK]: { [this.LIMITS_CRONS_SCHEDULE.RESET]: '0 * * * *' }, //limit per hour
    [this.SYSTEM_LIMITS_KEYS.AUTH_STORAGE]: { [this.LIMITS_CRONS_SCHEDULE.CALC]: '0 * * * *' },
    [this.SYSTEM_LIMITS_KEYS.SIGN_ON_AUTH_PEAK]: { [this.LIMITS_CRONS_SCHEDULE.RESET]: '0 * * * *' }, //limit per hour
    [this.SYSTEM_LIMITS_KEYS.DESKTOP_APP]: { [this.LIMITS_CRONS_SCHEDULE.CALC]: '0 * * * *' },
    [this.SYSTEM_LIMITS_KEYS.CONNECTED_DCS]: { [this.LIMITS_CRONS_SCHEDULE.CALC]: '0 * * * *' },
    [this.SYSTEM_LIMITS_KEYS.RISK_INDICATORS]: { [this.LIMITS_CRONS_SCHEDULE.CALC]: '0 * * * *' },
    [this.SYSTEM_LIMITS_KEYS.INCIDENTS]: { [this.LIMITS_CRONS_SCHEDULE.CALC]: '0 * * * *' },
    [this.SYSTEM_LIMITS_KEYS.ONGOING_INCIDENTS]: { [this.LIMITS_CRONS_SCHEDULE.CALC]: '0 * * * *' }
};

exports.AUTH_MODE_FILTERS_OPTIONS = {
    MONITORING: { value: 'monitored', label: 'Monitoring' },
    NTLM_FAIL_OPEN: { value: 'ntlmFailOpen', label: 'Monitoring - NTLM Fail-Open' },
    PROTECTING: { value: 'protected', label: 'Protecting' }
};

exports.USER_ENGAGEMENT_PAGE_KEYS = {
    SETTINGS_GENERAL: 'settings_general',
    SETTINGS_ADMIN_CONSOLE: 'admin_console',
    SETTINGS_DOMAINS: 'domains',
    SETTINGS_NODES: 'nodes',
    SETTINGS_AZ: 'avz',
    SETTINGS_MFA: 'mfa_tokens',
    SETTINGS_DESKTOP: 'desktop_application',
    SETTINGS_INTEGRATION: 'integrations',
    SETTINGS_API: 'api',
    SETTINGS_CUSTOM_INSIGHTS: 'custom_insights',
    SETTINGS_ADVANCED: 'advanced',
    SETTINGS_LICENSING: 'licensing',
    SETTINGS_ASSETS: 'settings_assets'
};

exports.NODES_OS_TYPES = {
    CENTOS_7: 'CentOS Linux 7 (Core)',
    OL_8: 'Oracle Linux Server 8'
};

exports.POLICY_SELECT_ACCOUNT_OPTIONS = {
    USERS: 'user',
    MACHINE_ACCOUNTS: 'machine',
    UNRESOLVED: 'unresolved',
    LOCAL: 'local'
};

exports.POLICY_SELECT_DESTINATION_OPTIONS = {
    SERVERS: 'server',
    UNRESOLVED: 'unresolved',
    IPS: 'ip'
};
exports.POLICY_SELECT_DESTINATION_OPTIONS = {
    SERVERS: 'server',
    UNRESOLVED: 'unresolved',
    IPS: 'ip'
};
exports.COMPONENTS_UPGRADE_STATUSES = {
    READY: 'Ready for update',
    IN_PROGRESS: 'In progress',
    UPDATED: 'Updated',
    ERROR: 'Not available',
    FAILED: 'Failed',
    OUTDATED: 'Unsupported Silverfort Version',
    NOT_SUPPORTED: 'Not Silverfort Machine',
    UNAVAILABLE: 'Unsupported During Early Availability'
};

exports.MIGRATION_SUPPORTED_VM_MANUFACTURERS = ['VMware, Inc.', 'Amazon EC2', 'Microsoft Corporation', 'Nutanix'];

exports.SILVERFORT_OS_TYPES = {
    V1: 'Silverfort OS V1',
    V2: 'Silverfort OS V2',
    DEFAULT: 'Silverfort OS V1'
};

exports.UPGRADABLE_TOWER_VERSION = '5';

exports.SECURITY_EVENTS_TYPES = {
    NEW_INCIDENT: { label: 'New incident', id: 'newIncident' },
    INCIDENT_AUTH_LOGS: { label: 'Incident events', id: 'incidentAuthLogs' },
    RISK_LEVEL: { label: 'Entity risk level change', id: 'riskLevel' },
    SA_ALERTS: { label: 'Service account violation', id: 'saAlerts' },
    POLICY_MATCH: { label: 'Policy match', id: 'policyMatch' },
    NEW_INSIGHT: { label: 'New posture insight', id: 'newInsight' },
    PA_ALERTS: { label: 'Privileged account violation', id: 'paAlerts' },
    DAILY_INSIGHTS: { label: 'Daily Exposures', id: 'dailyInsights' }
};

exports.CLOUD_EVENTS_TYPES = {
    CLOUD_NEW_THREAT: { label: 'New Threat', id: 'cloudNewThreat' },
    CLOUD_NEW_EXPOSURE: { label: 'New Posture Issue', id: 'cloudNewExposure' },
    CLOUD_EXPOSURE_CHANGED: { label: 'Existing Issue Status Changed', id: 'cloudExposureChanged' },
    IDENTITY_RISK_CHANGED: { label: 'Identity Risk Changed', id: 'identityRiskChanged' }
};

exports.PLATFORM_EVENTS_TYPES = {
    AUDIT: { label: 'Audit', id: 'audit' },
    SETTINGS: { label: 'Settings', id: 'settings' },
    INTEGRATIONS: { label: 'Silverfort Splunk app', id: 'integrations' },
    NOTIFICATIONS: { label: 'System events', id: 'notifications' }
};

exports.AUTHENTICATION_EVENTS_TYPES = {
    AUTHENTICATIONS: { label: 'Authentications', id: 'authentications' }
};

exports.EVENT_STREAMER_SUPPORTED_TYPES = {
    AUTH_EVENT: exports.AUTHENTICATION_EVENTS_TYPES.AUTHENTICATIONS.id,
    INCIDENT_EVENT: exports.SECURITY_EVENTS_TYPES.NEW_INCIDENT.id,
    ALL_EVENTS: '#'
};

exports.WEBHOOK_TYPES = {
    ...Object.fromEntries(
        Object.entries(this.SECURITY_EVENTS_TYPES).filter(
            ([, value]) => value.id !== this.SECURITY_EVENTS_TYPES.DAILY_INSIGHTS.id
        )
    )
};

exports.EMAIL_TYPES = {
    NOTIFICATIONS: this.PLATFORM_EVENTS_TYPES.NOTIFICATIONS
};

exports.SYSLOG_TYPES = {
    ...this.SECURITY_EVENTS_TYPES,
    ...this.PLATFORM_EVENTS_TYPES,
    ...this.AUTHENTICATION_EVENTS_TYPES
};

exports.ALPHANUMERIC_REGEX = /^[a-zA-Z0-9_\s-]+$/;
exports.URL_REGEX = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/;

exports.ALERTS_MANAGEMENT_OPTIONS_TYPES = {
    CHECKBOX: 'checkbox',
    TOGGLE: 'toggle',
    RADIO: 'radio',
    SELECT: 'select'
};
exports.WAF_COMPLIANT_STRING_PATTERN = /^[\p{L}\d\s\-?."_]+$/u;

exports.OLD_TO_NEW_PLACEHOLDER_MAPPING = {
    '<resource_name>': 'RESOURCE_NAME',
    '<link>': 'LINK',
    '</link>': 'END_LINK',
    '<link_name>': 'LINK_NAME',
    '</link_name>': 'END_LINK_NAME',
    '<link_ref>': 'LINK_REF',
    '</link_ref>': 'END_LINK_REF'
};

exports.NEW_TO_OLD_PLACEHOLDER_MAPPING = Object.entries(exports.OLD_TO_NEW_PLACEHOLDER_MAPPING).reduce(
    (acc, [key, value]) => ((acc[value] = key), acc),
    {}
);

exports.DEFAULT_VENDOR_TO_ID = {
    DEFAULT: 0,
    AZURE: 1,
    OKTA: 2,
    PING_FEDERATE: 3,
    ONE_LOGIN: 4,
    CYBER_ARK: 5,
    THALES_STA: 6,
    BEYOND_IDENTITY: 7
};

exports.CUSTOM_VENDOR_SEQUENCE_START = 10000;

exports.APP_USER_PERMISSIONS = {
    READ: { label: 'Read only', value: 'r' },
    WRITE: { label: 'Write only', value: 'w' },
    READ_WRITE: { label: 'Read & Write', value: 'rw' }
};

exports.PUBLIC_API_CATEGORIES = {
    SERVICE_ACCOUNTS: { label: 'Service Accounts', value: '0' },
    OPERATIONS: { label: 'Operations', value: '1' },
    RISK: { label: 'Risk', value: '2' },
    POLICIES: { label: 'Policies', value: '3' },
    ACCESS_ANALYSIS: { label: 'Access Intelligence', value: '4' },
    PRIVILEGED_ACCOUNTS: { label: 'Privileged Accounts', value: '5' },
    ENROLLMENT: { label: 'Enrollment', value: '6' }
};

exports.FIDO2_MODE_OPTIONS = {
    ON_PREM: 'on-prem',
    CLOUD: 'cloud'
};

exports.NEW_PRICING_MODULE_FIELDS_TITLES = ['basePlatform', 'mfaUsers', 'serviceAccounts', 'authenticationFirewall'];

exports.LEGACY_PRICING_MODULE_FIELDS_TITLES = ['numOfMonitoredUsers', 'numOfProtectedUsers'];

exports.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT = {
    BASE_PLATFORM: 'basePlatform',
    MFA_USERS: 'mfaUsers',
    SERVICE_ACCOUNTS: 'serviceAccounts',
    AUTHENTICATION_FIREWALL: 'authenticationFirewall',
    PRIVILEGED_ACCESS_SECURITY: 'privilegedAccessSecurity',
    NHI_VISIBILITY: 'nhiVisibility',
    CLOUD_NHI: 'cloudNhi', // V2 license schema
    NHI_PROTECTION: 'nhiProtection',
    ISPM: 'ispm',
    ITDR: 'itdr',
    ACCESS_ANALYSIS: 'accessAnalysis',
    AI_AGENTS_SECURITY: 'aiAgentsSecurity',
    AI_AGENTS_PROTECTION: 'aiAgentsProtection'
};

exports.LEGACY_PRICING_MODULE_FIELDS_TITLES_OBJECT = {
    NUM_OF_MONITORED_USERS: 'numOfMonitoredUsers',
    NUM_OF_PROTECTED_USERS: 'numOfProtectedUsers'
};

exports.LOGS_FOLDERS = {
    walls: '/opt/silverfort/persistent/tower/internal_data/nodes',
    dcs: '/opt/silverfort/persistent/tower/internal_data/DCs',
    adConnect: '/opt/silverfort/persistent/tower/internal_data/ad-connect',
    arya: '/opt/silverfort/persistent/tower/internal_data/push_services',
    tower: '/opt/silverfort/persistent/tower/internal_data/tower'
};

exports.AUTH_FOLDER = '/opt/silverfort/persistent/tower-core-api';

exports.AUTH_FILENAME = 'authentications.txt';

exports.BACKUP_INTERVAL_OPTIONS = {
    never: { label: 'Never', value: 'never' },
    daily: { label: 'Daily', value: 'daily' },
    weekly: { label: 'Weekly', value: 'weekly' },
    monthly: { label: 'Monthly', value: 'monthly' }
};

exports.FILE_SYSTEM_OPTIONS = {
    azure: { label: 'Azure', value: 'azure' },
    aws: { label: 'AWS', value: 'aws' },
    smb: { label: 'Local', value: 'smb' }
};

exports.AZURE_AUTH_TYPE_OPTIONS = {
    sasToken: { label: 'SAS Token', value: 'sasToken' },
    sharedKey: { label: 'Shared Key', value: 'sharedKey' }
};

exports.NEW_DAYS_OPTIONS = {
    0: { label: 'Sunday', value: 0 },
    1: { label: 'Monday', value: 1 },
    2: { label: 'Tuesday', value: 2 },
    3: { label: 'Wednesday', value: 3 },
    4: { label: 'Thursday', value: 4 },
    5: { label: 'Friday', value: 5 },
    6: { label: 'Saturday', value: 6 }
};

exports.LICENSE_TYPES = {
    LICENSE_SERVER: 'license_server',
    LEGACY_FLOW_LICENSE: 'legacy_flow_license'
};

exports.TOKEN2_DEVICE_TITLE = 'Token2';

exports.PRIVILEGED_ACCOUNTS_STATUS = {
    Enabled: 0,
    Disabled: 1,
    Enabling: 2,
    Disabling: 3
};
exports.JIT_MFA_TYPES = {
    MFA: { title: 'Require MFA', value: 1 },
    BRIDGE: { title: 'Require Identity Bridge', value: 2 },
    NONE: { title: 'None', value: 0 }
};

exports.EQUATION_FILTERS_OPTIONS = [
    {
        title: 'Greater than',
        value: '>'
    },
    {
        title: 'Exactly',
        value: '='
    },
    {
        title: 'Lower than',
        value: '<'
    }
];

exports.PRIVILEGED_ACCOUNTS_FILTERS = {
    status: {
        id: 'status',
        title: 'Account status',
        options: Object.keys(this.PRIVILEGED_ACCOUNTS_STATUS).map((status) => ({
            title: status,
            value: this.PRIVILEGED_ACCOUNTS_STATUS[status]
        })),
        multiple: true
    },
    policy: {
        id: 'policy',
        title: 'Policy',
        multiple: true,
        options: [
            { title: 'JIT policy', value: 'jit' },
            { title: 'Virtual fencing', value: 'fencing' },
            { title: 'Not Protected', value: 'not protected' }
        ]
    },
    crossTier: {
        id: 'crossTier',
        title: 'Cross Tier',
        equation: true,
        options: this.EQUATION_FILTERS_OPTIONS
    },
    sources: {
        id: 'sources',
        title: 'Sources',
        equation: true,
        options: this.EQUATION_FILTERS_OPTIONS
    },
    destinations: {
        id: 'destinations',
        title: 'Destinations',
        equation: true,
        options: this.EQUATION_FILTERS_OPTIONS
    },
    group: {
        id: 'group',
        title: 'Group / OU',
        searchable: true,
        disableSelectAll: true,
        options: [],
        serachHandler: () => {}
    }
};
exports.PRIVILEGE_ACCOUNTS_ALL_SERVICES = '*';

exports.JIT_SOURCE = {
    adminConsole: 1,
    ad: 2,
    system: 3
};

exports.FENCING_TABS = [
    { name: 'Sources', value: 0 },
    { name: 'Destinations', value: 1 },
    { name: 'Protocols', value: 2 }
];

exports.TIER_PART_TYPES = {
    GROUPS: 'groups',
    OUS: 'ous',
    SERVERS: 'servers',
    IPS: 'ips',
    CONDITIONS: 'conditions'
};

exports.PRIVILEGED_DEFAULT_SERVICES = [
    'dcom',
    'exchangeab',
    'host',
    'iisadmin',
    'mssql',
    'mssqlsvc',
    'netlogon',
    'rpc',
    'rpcss',
    'scm',
    'termsrv',
    'wsman'
];

exports.DCS_PRIVILEGED_DEFAULT_SERVICES = [
    'dcom',
    'exchangeab',
    'host',
    'iisadmin',
    'mssql',
    'mssqlsvc',
    'netlogon',
    'rpcss',
    'scm',
    'termsrv',
    'wsman'
];

exports.REDIS_EXPORTER_DEFAULT_MONITORED_FIELDS = [
    'redis_cpu_sys_seconds_total',
    'redis_memory_used_rss_bytes',
    'redis_memory_used_peak_bytes',
    'redis_connected_slaves',
    'redis_connected_clients',
    'redis_db_keys',
    'redis_instance_info'
];

exports.REPORTS_DATE_FORMAT = 'MM/DD/YYYY';

exports.LAST_USE_NOT_SEEN = 'Not seen';
exports.INSIGHTS_FIELD_TYPES = {
    REMOTE_FIELDS: {
        GUID: 'guid'
    },
    RAW_FIELDS: {
        DATE: 'date',
        OPTIONAL_DATE: 'optional_date',
        ENCRYPTION_TYPE: 'encryption_type',
        CUSTOM_FUNCTION: 'custom_function',
        PRETTY_LIST: 'pretty_list'
    },
    PRIMITIVE_FIELDS: {
        STRING: 'string',
        NUMBER: 'number'
    }
};

exports.INSIGHTS_REASON_FIELDS_REGEX = /\${(.*?)}/g;

exports.CSV_UPLOAD_BAD_REQ_MESSAGES = {
    FILE_EXTENSION: `Only files with the '.CSV' extension are supported.`,
    UPLOAD_RATE: 'File upload rate is too high.',
    EMPTY_FILE: 'The file is empty.',
    WRONG_FORAMT: 'Only the export file format is supported.',
    MAXIMUM_INPUTS: `A maximum of <max-amount> entries may be uploaded.`
};

exports.PRODUCT_DATA_API_TYPES = {
    UPDATE_SERVICE_ACCOUNT_POLICY: 'updateServiceAccountPolicy',
    GET_SERVICE_ACCOUNTS_PAGE: 'getServiceAccountsPage',
    GET_SERVICE_ACCOUNT: 'getServiceAccount',
    HIDE_OR_REMOVE_SERVICE_ACCOUNT: 'hideOrRemoveServiceAccount',
    UPDATE_SERVICE_ACCOUNT: 'updateServiceAccount',
    CREATE_SERVICE_ACCOUNT: 'createServiceAccount',
    GET_SERVICE_ACCOUNT_POLICY: 'getServiceAccountPolicy',
    SEARCH_GUIDS: 'searchGuids'
};

exports.API_VERSION = {
    V1: 'v1',
    V2: 'v2'
};

exports.INTEGRATION_EVENT_TYPES = {
    NEW_INCIDENT: 'newIncidentV2',
    INCIDENT_UPDATE: 'incidentUpdateV2',
    RISK_LEVEL_CHANGE: 'riskLevelChangeEvent',
    THREAT: 'threatEvent',
    CONFIG: 'configurationSyncEvent'
};

exports.INVENTORY_FILTERS_KEYS = {
    CREATION_DATE: 'creation_date',
    DOMAINS: 'domain_name',
    RISK: 'risk_level',
    RISK_INDICATORS: 'risk_indicators',
    DISABLED: 'disabled'
};
exports.SSO_APP_SOURCE_TYPE = {
    INTEGRATIONS: 'integrations',
    MFA_TOKENS: 'mfa_tokens'
};

exports.ENTRA_ID_SSO_APP_OFFSET = 10000;

exports.ACCOUNT_MATCHING_TYPES = {
    AD_FIELDS: 'AdFields'
};

// File permissions
exports.FILE_PERMISSIONS = {
    OWNER_READ_WRITE: 0o600 // Read and write for owner only (sensitive files like keys)
};

exports.RISK_REPORT_MODULES = {
    EXECUTIVE_SUMMARY: 'Executive Summary',
    UNIFIED_VISIBILITY: 'Unified Visibility',
    UNIVERSAL_MFA: 'Universal MFA & Authentication Firewall',
    ISPM: 'ISPM',
    ITDR: 'ITDR',
    SERVICE_ACCOUNTS: 'Service Accounts',
    PAS: 'Privileged Access Security',
    ABOUT: 'About Silverfort'
};

exports.REPORT_MODULES_DATA = {
    [this.RISK_REPORT_MODULES.EXECUTIVE_SUMMARY]: { title: 'Executive Summary', licenseModules: [] },
    [this.RISK_REPORT_MODULES.UNIFIED_VISIBILITY]: { title: 'Unified Visibility', licenseModules: [] },
    [this.RISK_REPORT_MODULES.UNIVERSAL_MFA]: {
        title: 'Universal MFA',
        licenseModules: [
            this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.MFA_USERS,
            this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.AUTHENTICATION_FIREWALL
        ]
    },
    [this.RISK_REPORT_MODULES.ISPM]: {
        title: 'ISPM',
        licenseModules: [this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.ISPM]
    },
    [this.RISK_REPORT_MODULES.ITDR]: {
        title: 'ITDR',
        licenseModules: [this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.ITDR]
    },
    [this.RISK_REPORT_MODULES.SERVICE_ACCOUNTS]: {
        title: 'Service Accounts',
        licenseModules: [
            this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.NHI_VISIBILITY,
            this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.NHI_PROTECTION
        ]
    },
    [this.RISK_REPORT_MODULES.PAS]: {
        title: 'Privileged Access Security',
        licenseModules: [this.NEW_PRICING_MODULE_FIELDS_TITLES_OBJECT.PRIVILEGED_ACCESS_SECURITY]
    },
    [this.RISK_REPORT_MODULES.ABOUT]: { title: 'About', licenseModules: [] }
};

exports.PHOENIX_URL_REGEX = /^https:\/\/[a-z0-9-]+\.services\.silverfort\.(com|dev)$/;

exports.isValidPhoenixUrl = (url) => exports.PHOENIX_URL_REGEX.test(url?.toLowerCase());
